<template>
    <div>
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="h-piece" style="margin:20px">
            <div class="h-pieceTitle2">
                <h1>项目信息</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine h-enter enter">
                    <el-form :model="ProMain" label-position="right" ref="formLabelAlign" :inline="true"
                             class="demo-ruleForm h-formbLine" :rules="rules">
                        <el-form-item label="项目名称" class="h-elformWrap-2" v-if="ispro">
                            <el-input v-model="ProMain.projectName" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="投标方式" class="h-elformWrap-2" prop="bidway">
                            <el-input v-model="ProMain.bidway" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="开标日期" class="h-elformWrap-2" prop="bid" v-if="ispro">
                            <el-col :span="11">
                                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                                                v-model="ProMain.bid" style="width: 2.65rem;" :clearable="false"
                                                disabled="disabled"></el-date-picker>
                            </el-col>
                            <!--                            <el-input v-model="ProMain.bid" placeholder="" disabled="disabled"></el-input>-->
                        </el-form-item>
                        <el-form-item label="保修期" class="h-elformWrap-2" prop="repairtype">
                            <el-select v-model="repairtype" placeholder="" @change="repairchangetype"
                                       disabled="disabled">
                                <el-option v-for="item in repairOptions" :key="item.value"
                                           :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="预付百分比%" class="h-elformWrap-2" prop="pdpay">
                            <el-input v-model.number="ProMain.pdpay" placeholder="请输入.xxx"
                                      @blur="pdpaychange(ProMain.pdpay)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="首款百分比%" class="h-elformWrap-2" prop="fdpay">
                            <el-input
                                    v-model.number="ProMain.fdpay" placeholder="请输入.xxx"
                                    @blur="fdpaychange(ProMain.fdpay)"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="中款百分比%" class="h-elformWrap-2" prop="mdpay">
                            <el-input v-model.number="ProMain.mdpay" placeholder="请输入.xxx"
                                      @blur="mdpaychange(ProMain.mdpay)"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="尾款百分比%" class="h-elformWrap-2" prop="ldpay">
                            <el-input v-model.number="ProMain.ldpay" placeholder="请输入.xxx"
                                      @blur="ldpaychange(ProMain.ldpay)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="首款天" class="h-elformWrap-2" prop="fdpayday">
                            <el-input
                                    v-model.number="ProMain.fdpayday" placeholder=""
                                    oninput="value=value.replace(/[^\d]/g, '')"
                                    maxlength="3">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="中款天" class="h-elformWrap-2" prop="mdpayday">
                            <el-input
                                    v-model.number="ProMain.mdpayday" placeholder=""
                                    oninput="value=value.replace(/[^\d]/g, '')"
                                    maxlength="3">
                            </el-input>

                        </el-form-item>
                        <el-form-item label="尾款天" class="h-elformWrap-2" prop="ldpayday">
                            <el-input
                                    v-model.number="ProMain.ldpayday" placeholder=""
                                    oninput="value=value.replace(/[^\d]/g, '')"
                                    maxlength="3">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="项目背景" class="h-elformWrap-2" v-if="ispro">
                            <el-input
                                    v-model="ProMain.projectDescription" placeholder=""
                                    disabled="disabled"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="终端成交" class="h-elformWrap-2" v-if="ispro">
                            <el-input v-model="ProMain.zhongduanchengjiaojia" placeholder=""
                                      disabled="disabled"></el-input>
                            <!--                            <el-select v-model="ProMain.zhongduanchengjiaojia" placeholder="请选择">-->
                            <!--                                <el-option label="类型一" value="type1"></el-option>-->
                            <!--                                <el-option label="类型二" value="type2"></el-option>-->
                            <!--                            </el-select>-->
                        </el-form-item>
                        <el-form-item label="专营商毛利率" class="h-elformWrap-2" v-if="ispro">
                            <el-input v-model="ProMain.zhuanyingshangmaolilv" placeholder=""
                                      disabled="disabled"></el-input>
                        </el-form-item>

                        <!-- <el-form-item label="送达地址" class="h-elformWrap-2">

                            <el-input v-model="ProMain.songdadizhi" placeholder="请输入" disabled="disabled"></el-input>

                        </el-form-item> -->


                     <!--    <el-form-item label="送达城市" class="h-elformWrap-2">


                            <el-select v-model="ProMain.songdachengshi" placeholder="送达地址带出" filterable clearable
                                       disabled="disabled">
                                <el-option
                                        v-for="(item,index) in songdachengshilist"
                                        :key="index"
                                        :label="`[${item.code}]${item.name}`"
                                        :value="item.code+'_'+item.name">
                                </el-option>
                            </el-select>

                        </el-form-item> -->




                       <!--  <el-form-item label="客户" class="h-elformWrap-2" style="position:relative"
                                      prop="xuanzhongren">
                            <el-input v-model="ProMain.xuanzhongren" placeholder="请输入" readonly>
                            
                            </el-input>
                        </el-form-item> -->

                        <!--                        <showxuanzerencesuan-->
                        <!--                                :visible.sync="xuanzeren"-->
                        <!--                                v-if="xuanzeren"-->
                        <!--                                @choseObj="shiyongrenxuanze"-->
                        <!--                                oneflag-->
                        <!--                                title="选择经销商"  />-->

                        <br>
                        <el-form-item class="h-elformWrap-1 ljjrange" label="选择特价有效期" prop="youxiaoqi"
                                      >
                            <el-col>

                                <!--                                <el-date-picker type="date" placeholder="选择时间" v-model="ProMain.youxiaoqi" value-format="yyyy-MM-dd" disabled="disabled"></el-date-picker>-->


                                <el-date-picker
                                        v-model="ProMain.youxiaoqi"
                                        type="daterange"
                                        range-separator=" 至 "
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        style="width: 6rem"
                                        value-format="yyyy-MM-dd"
                                        disabled="disabled"
                                >
                                </el-date-picker>


                            </el-col>
                        </el-form-item>


                    </el-form>


                    <div class="anniu" v-if="guanliyuan || caiwu" style="margin-left: 0;">
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="gongshiduizhaokai">公式对照表
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xiangxixinxixianshi">显示详细计算信息
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="kankanyichang">
                            异常信息
                        </el-button>
                    </div>

                </div>
            </div>
        </div>
        <div class="h-table ljjtableenterlknsp" style="margin:20px">
            <el-table
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @cell-dblclick="dblclick"
                    border
					max-height="500"
                    style="width: 100%; margin-top: 20px">
                <el-table-column
                        prop="message"
                        label="分类"
                        width="140"
						:show-overflow-tooltip="true"
                        fixed
                >
                </el-table-column>
                <el-table-column
                        prop="coding"
                        label="科目"
                        :show-overflow-tooltip="true"
						fixed
                        width="190"
                >
                </el-table-column>
                <el-table-column
                        prop="shuoming"
                        label="说明"
                        :show-overflow-tooltip="true"
                        min-width="200"
                >
                </el-table-column>
                <el-table-column
                        prop="biaozhun"
                        width="120"
                        label="标准/单台">
                </el-table-column>
                <el-table-column
                        prop="hejiL"
                        width="140"
                        label="合计-率">
						<template slot-scope="scope">
							<div v-if="scope.row.hejiL == '-'">{{scope.row.hejiL}}
							</div>
							<div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">{{scope.row.hejiL}}
							</div>
							<div v-else :title="scope.row.hejiL">{{new big(Number(scope.row.hejiL).toFixed(2)).times('100') + '%'}}</div>
							<!-- <div v-else :title="scope.row.hejiL">{{((Math.round(scope.row.hejiL * 100) / 100)*100) + '%'}}</div> -->
							<!-- .toFixed(2) -->
						</template>
                </el-table-column>
                <el-table-column
                        width="140"
                        prop="hejiE"
                        label="合计-额">
						<template slot-scope="scope">
							<div v-if="scope.$index==5||scope.$index==7||scope.$index==19||scope.$index==39||scope.$index==45||scope.$index==49||scope.$index==50||scope.$index==51||scope.$index==52||scope.$index==53||scope.$index==54||scope.$index==55||scope.$index==56||scope.$index==57||scope.$index==58||scope.$index==59||scope.$index==60" :title="scope.row.hejiE">{{new big(Number(scope.row.hejiE).toFixed(2)).times('100') + '%'}}
							</div>
							<div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">{{scope.row.hejiE}}
							</div>
						<!-- 	<div v-else :title="scope.row.hejiE">{{Math.round(scope.row.hejiE * 100) /
							    100}}
							</div> -->
							<div v-else :title="scope.row.hejiE">{{Number(scope.row.hejiE).toFixed(2)}}</div>
						</template>
                </el-table-column>

                <el-table-column
                        min-width="150"
                        :prop="item.prop"
                        :label="item.label" v-for="item in columndata" :key='item.label'>

                    <!--						<template slot-scope="scope">-->
                    <!--                            <div v-if="scope.row">{{scope.row[item.prop]}}</div>-->
                    <!--							<el-input v-model="scope.row[item.prop]" v-else></el-input>-->
                    <!--						</template>-->


                    <template slot-scope="scope">


                        <div v-if="scope.$index == 0 || scope.$index == 1 || scope.$index == 2 || scope.$index == 3">{{scope.row[item.prop]}}</div>
                        <div v-else-if=" scope.$index == 10 || scope.$index == 11 || scope.$index == 12 || scope.$index == 13 || scope.$index == 14 || scope.$index == 15 || scope.$index == 17 || scope.$index == 18 || scope.$index == 19 || scope.$index == 37 || scope.$index == 38 || scope.$index == 39 || scope.$index == 43 || scope.$index == 44 || scope.$index == 45
">{{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}</div>
                        <el-input class="h-tableInput" v-else-if="scope.row['flags' + item.flagsindex]==true" v-focus v-model="scope.row[item.prop]" @blur="caiwugaishula(scope.row,scope.row[item.prop],item.flagsindex)"></el-input>
                        <div style="border:1px solid #DCDFE6;padding: 0.05rem 0;text-align: left;padding-left: 0.1rem;" v-else :title="scope.row[item.prop]" @click="clickjiage(scope.row,item.flagsindex)">{{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}</div>


                    </template>

                </el-table-column>


                <!--            <el-table-column-->
                <!--                    prop="xiugai"-->
                <!--                    label="修改"-->
                <!--            >-->
                <!--                <template slot-scope="scope">-->
                <!--                    <div style="display:flex">-->
                <!--                        <el-select v-model="changeelse" placeholder="请选择" @change="elsechangetype">-->
                <!--                            <el-option v-for="item in changeelseOptions" :key="item.value"-->
                <!--                                       :label="item.label" :value="item.value">-->
                <!--                            </el-option>-->
                <!--                        </el-select>-->
                <!--                        <el-input v-model="scope.row.xiugai" placeholder="请输入"></el-input>-->
                <!--                        <el-button-->
                <!--                                type="text"-->
                <!--                                size="small"-->
                <!--                                class="h-tableLink"-->
                <!--                                @click="changetogo(scope.row.xiugai)">-->
                <!--                            修改-->
                <!--                        </el-button>-->
                <!--                    </div>-->
                <!--                </template>-->
                <!--            </el-table-column>-->

            </el-table>


            <!--            <div class="h-tableB h-mrt30" style="height: 1rem;">-->

            <!--                <div class="h-pagination2 ">-->
            <!--                    <paginationminNosize :page="q" @query="query"/>-->
            <!--                </div>-->
            <!--            </div>-->


        </div>
        <!--        <div class="drags" style="width:96.5%;padding:0 38px;margin-left:21px;margin-top:-20px;">-->
        <!--            <el-slider v-model="value3" :show-tooltip="true" :show-stops="true" @change="gotonextpage"></el-slider>-->
        <!--        </div>-->





        <div style="margin:20px" v-if="xianshinage==0">
            <div class="yx_progressBar">
                <div class="yxExtra">
                    <div style="margin-bottom: 0.2rem;" v-if="taskstatus==0">该申请价格达到盈利目标</div>
                </div>
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong!=null&&jingyinggongxiangzong!=''&&jingyinggongxiangzong!=0?(parseFloat(jingyinggongxiangzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[39].hejiE==null||this.tableData[39].hejiE==''?0:((parseFloat(this.tableData[39].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong!=null&&lirunzong!=''&&lirunzong!=0?(parseFloat(lirunzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[45].hejiE==null||this.tableData[45].hejiE==''?0:((parseFloat(this.tableData[45].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>
                </div>
                <!--            <div class="con_progress">-->
                <!--                <div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
                <!--                    <div class="eve_pro">-->
                <!--                        <div class="persons">{{item.name}}</div>-->
                <!--                    </div>-->
                <!--                    <div class="line_pro"></div>-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
        </div>


        <div v-else style="margin:0 20px ">
            <div class="yx_progressBar yx_progressBarAc">
                <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                    <div style="margin-bottom: 0.2rem;" v-if="taskstatus==0"></div>
                </div>
                <!--                <el-button class="h-btn h-bgblueQ2" @click="tijiaoshenqingtejia" style="position:absolute;top:0.3rem;right: 0.7rem">去提交</el-button>-->
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong!=null&&jingyinggongxiangzong!=''&&jingyinggongxiangzong!=0?(parseFloat(jingyinggongxiangzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[39].hejiE==null||this.tableData[39].hejiE==''?0:((parseFloat(this.tableData[39].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong!=null&&lirunzong!=''&&lirunzong!=0?(parseFloat(lirunzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[45].hejiE==null||this.tableData[45].hejiE==''?0:((parseFloat(this.tableData[45].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>
                </div>
                <!--            <div class="con_progress">-->
                <!--                <div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
                <!--                    <div class="eve_pro" :class="{eve_proAc:item.ifBlue==1,eve_proAcpass:item.ifBlue ==2}">-->
                <!--                        <div class="persons" :class="{personsAc:item.ifBlue==1}">{{item.name}}</div>-->
                <!--                    </div>-->
                <!--                    <div class="line_pro" :class="{line_proAc:item.ifBlue==1,line_proAcpass:item.ifBlue == 2}"></div>-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
        </div>


        <div v-if="!zhidumoshi">


        <div class="xia" style="margin-top: 0.4rem;margin-bottom: 0.4rem;">
            <el-button  class="h-btn h-bBtn h-bgblueQ2"
                       @click="caiwujisuan" v-if="taskstatus==0">计算
            </el-button>

        </div>


        <!-- <div class="h-pieceIn2">
            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                <h1>盈利测算审批</h1>
            </div>
            <div class="h-pieceCon2"
                 style="width:100%;padding:10px;background:#fcfcfc;border-radius:10px;border:1px solid #ccc">
                <div class="h-formLine weekplandetail">
                    <el-form :model="yinglishenpi" label-position="right" ref="yinglishenpi" :inline="true"
                             :rules="shenpirules" class="demo-ruleForm h-formbLine">
                        <div class="h-txtLeft h-mrt60">
                            <el-form-item label="审批意见" class="h-elformWrapz-2" prop="shenheyijian">
                                <el-input v-model="yinglishenpi.shenheyijian" placeholder="审批意见" :disabled="taskstatus==1"></el-input>
                            </el-form-item>
                            <br>
                        </div>
                    </el-form>
                </div>
            </div>
        </div> -->
        <div class="h-table h-mrt30 h-rowBox cccc" style="margin:0.2rem">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1" style="margin-left:0.2rem">审批意见</h1>
                <el-form :model="yinglishenpi" label-position="right" ref="yinglishenpi" :inline="true"
                         :rules="shenpirules" class="demo-ruleForm h-formbLine">
                    <div class="h-txtLeft">
                        <el-form-item label="审批意见" class="h-elformWrapz-1" prop="shenheyijian"
                                      style="margin-top:0.2rem;margin-left: 0.2rem;">
                            <el-input v-model="yinglishenpi.shenheyijian" placeholder="审批意见" style="width:4rem"
                                      :disabled="taskstatus==1"></el-input>
                        </el-form-item>
                        <br>
                    </div>
                </el-form>
            </div>
        </div>

        <div class="anniu" style="display: flex;justify-content: center;align-items: center;margin-left: 0;">
			<el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
            <el-button size="small" class="h-btn h-bBtn h-bgwhite" @click="caiwuzancunyuanshibanben">
                原始审批版本查看
            </el-button>
            <el-button size="small" class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanbencaiwuzancun">
                查看暂存
            </el-button>

            <el-button class="h-btn h-bBtn h-bgblueQ2"
                       @click="xiugaitijiao"  v-if="taskstatus==0">
                修改提交通过
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" @click="caiwuzancun" v-if="taskstatus==0">
                暂存
            </el-button>

            <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="bohuianniu('yinglishenpi',1)"
                       v-if="taskstatus==0">驳回
            </el-button>
            <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="tongguoanniu(2)"
                       v-if="taskstatus==0">原版通过
            </el-button>
			<el-button
			        v-if="!caiwugaishutongguo"
			        size="small" class="h-btn h-bBtn"
			        @click="showhistory = true">
			    跟踪审批
			</el-button>
			
<!--            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="viewpress">审批跟踪-->
<!--            </el-button>-->
        </div>

        </div>

        


        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


        <!--        &lt;!&ndash; 驳回弹窗 &ndash;&gt;-->
        <!--        <el-dialog :visible.sync="refuseDialog" class="h-dialog2"  @close="gettable">-->
        <!--            <div class="h-dialogImg">-->
        <!--                <div class="h-disTable">-->
        <!--                    <div class="h-tableCell">-->
        <!--                        <h1>选择以往测算版本</h1>-->
        <!--                        <p>Selection process</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->


        <!--            <div class="h-formLines">-->
        <!--                <div style="padding: 40px;">-->

        <!--                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">-->
        <!--                        <el-option v-for="item in banbenop" :key="item.value"-->
        <!--                                   :label="item.label" :value="item.value">-->
        <!--                        </el-option>-->

        <!--                    </el-select>-->

        <!--                    <div style="text-align: right;margin-top: 5%">-->
        <!--                        <el-button class="h-btn h-formBtn" style="" @click="refuseDialog=false">确定</el-button>-->
        <!--                    </div>-->

        <!--                </div>-->


        <!--            </div>-->


        <!--        </el-dialog>-->


        <!-- 选择财务暂存版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="showcaiwuzancun" class="h-dialog2" @close="gettablecaiwuzancun">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择财务暂存版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="showcaiwuzancun=false">确定</el-button>
                    </div>

                </div>

            </div>


        </el-dialog>


        <!-- 计算详细记录 -->
        <el-dialog :visible.sync="xiangxijilu" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="xiangxijilujieguo" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="xiangxijilu=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 公式对照表 -->
        <el-dialog :visible.sync="gongshiduizhao" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="gongshiduizhaobiao" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="gongshiduizhao=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 异常信息 -->
        <el-dialog :visible.sync="jianchayichang" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="yichangxinxi" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jianchayichang=false">确定</el-button>
            </div>


        </el-dialog>


    </div>
</template>
<style scoped>
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }
</style>

<style scoped lang="scss">
    $ft-colorg: #21d16f; //绿色的字
    $ft-coloro: #e79118; //黄色的字
    $bg-colorg: #f6fffa; //绿色的背景色
    $bg-coloro: #fffbf7; //黄色的背景色
    $bg-colorb: #3b77fc; //蓝色
    $bg-colorgrey: #c3c3c3; //灰色
    .yx_progressBar {
        width: 100%;
        border: 1px solid $ft-colorg;
        background-color: $bg-colorg;
        padding: 0.38rem;
        padding-bottom: 0.6rem;
        position: relative;

        .yxExtra {
            position: absolute;
            color: $ft-colorg;
            top: 0.3rem;
            font-size: 0.18rem;
            right: 0.3rem;
        }

        .yx_topTip {
            display: flex;
            justify-content: flex-start;
            color: #424441;
            font-size: 0.18rem;

            .leftdes {
                margin-right: 0.75rem;
            }

            .percent {
                color: $ft-colorg;
            }
        }

        // .con_progress {
        //     display: flex;
        //     justify-content: flex-start;
        //     align-items: center;
        //     margin-top: 0.3rem;

        //     .eve_proout {
        //         display: flex;
        //         align-items: center;
        //         justify-content: flex-start;

        //         &:last-child .line_pro {
        //             display: none;
        //         }

        //         .eve_pro {
        //             width: 20px;
        //             height: 20px;
        //             border-radius: 50%;
        //             position: relative;
        //             background-color: $bg-colorgrey;

        //             .persons {
        //                 position: absolute;
        //                 top: 20px;
        //                 min-width: 1.8rem;
        //                 text-align: center;
        //                 margin-left: -0.75rem;
        //                 margin-top: 0.04rem;
        //                 font-size: 0.18rem;
        //             }

        //             .personsAc {
        //                 color: $bg-colorb;
        //             }
        //         }


        //         .line_pro {
        //             width: 3rem;
        //             height: 4px;
        //             background-color: $bg-colorgrey;
        //         }

        //         // 激活
        //         .eve_proAc {
        //             background-color: $bg-colorb;
        //         }

        //         .line_proAc {
        //             width: 3rem;
        //             height: 4px;
        //             background-color: $bg-colorb;
        //         }

        //         .eve_proAcpass {
        //             background-color: $bg-colorgrey;
        //         }

        //         .line_proAcpass {
        //             width: 3rem;
        //             height: 4px;
        //             background-color: $bg-colorb;
        //         }
        //     }

        // }
    }

    .yx_progressBarAc {
        border: 1px solid $ft-coloro;
        background-color: $bg-coloro;

        .yxExtra {
            color: $ft-coloro;
        }

        .yx_topTip {
            .percent {
                color: $ft-coloro;
            }
        }
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
        display: flex;
        justify-content: center;
        margin-top: 0.7rem
    }
</style>

<script>
    import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        components: {
            showxuanzerencesuan
        },


        data() {

            return {

                caiwuzancunlist:[],

                zancunid:'',

                dangqiancaiwuzancun:false,

                showcaiwuzancun:false,

				baocunbianliangb:'',

                shenpiyijianshow:false,

                //只读版本id
                cesuanid:'',

                //财务改数直接通过的没有审批流
                caiwugaishutongguo:false,

                //只读
                zhidumoshi:false,

                caiwu:false,

                jisuancishu:0,

                baocuntable: [],

                caiwuzhijiexiugaitijiaoshanchubanben:'',

                //被改数的
                beigaishude:[],

                shenpiyemian:true,

                yichangxinxi: '',

                jianchayichang: false,

                gongshiduizhaobiao: '',

                gongshiduizhao: false,

                guanliyuan: false,

                xiangxijilu: false,

                xiangxijilujieguo: '',

                songdachengshilist: [],

                xuanzeren: false,

                ispro: true,

                taskstatus: '',

                showhistory: false,

                tonguoorbohui: '',

				zancunbianlianga:'',

                yinglishenpi: {

                    shenheyijian: '',

                },

                shenpirules: {
                    shenheyijian: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                },


                //instid
                instid: null,

                //业务id
                ywid: null,

                //taskid
                taskid: null,

                //选择项目参数
                rateFormulaRenewXiangmucanshu: null,

                //计算返回版本id
                fanhuibanbenid: null,

                //计算版本
                rversion: null,


                guochenglist: [],

                xuanzhongbanben: [],

                refuseDialog: true,


                banbenid: '',


                banbenop: [],


                //计算过程对象
                rateFormulaRenewVer: {},


                //显示哪个利率总计框
                xianshinage: 9,

                jingyinggongxiangzong: 0,

                lirunzong: 0,

                zongmaolilvbiao: 0,

                zongmaolilv: 0,


                // 进度
                progressBar: [
                    {name: "王振刚", ifBlue: 1, ifing: 0},
                    {name: "总部管理员", ifBlue: 1, ifing: 0},
                    {name: "财务经理", ifBlue: 2, ifing: 0},
                    {name: "待审核", ifBlue: 0, ifing: 0},
                ],

                list: [
                    {
                        title: '提交人:王振刚',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '总部管理员',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '待审核',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '财务经理',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    }
                ],


                //物料号
                marcode: '',


                rules: {
                    bidway: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    bid: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    repairtype: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    pdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    fdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    mdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    ldpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    fdpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    mdpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    ldpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],


                },


                //项目产品list
                xiangmuchanpinlist: [],


                q: {

                    pageSize: 5,
                    pageNo: 1,
                    total: 0,

                },

                //全合计金额map
                allratemap: {},


                //是否首次交互
                shoucijiaohu: true,

                //申请单价含税 组
                shenqingdanjiaop: [],

                //附加成本 组
                fujiachengbenop: [],

                //中标服务费 组
                zhongbiaofuwufei: [],

                //中标服务费
                zhongbiaofuwufei: "",

                //附加成本
                fujiachengben: "",

                //申请单价含税
                shenqingdanjia: '',

                //项目编号
                proid: "zckceshi",

                //质保选中值
                repairtype: '正常质保',

                repairOptions: [{
                    value: '正常质保',
                    label: '正常质保'
                }, {
                    value: '五年质保',
                    label: '五年质保'
                }],
                //
                columndata: [],

                //列表翻页参数
                value3: 0,

                //上部列表信息
                ProMain: {

                    //送达地址
                    //songdadizhi: '',

                    //送达城市
                    //songdachengshi: '',

                    //选中人
                    //xuanzhongren: '',
                    //使用人
                    //shiyongren: '',

                    //有效期
                    youxiaoqi: ['', ''],

                    //项目名称
                    projectName: '',

                    //投标方式
                    bidway: '',

                    //开标日期
                    bid: '',

                    //预付百分比
                    pdpay: '',

                    //首款百分比
                    fdpay: '',

                    //中款百分比
                    mdpay: '',

                    //尾款百分比
                    ldpay: '',

                    //首款天
                    fdpayday: '',

                    //中款天
                    mdpayday: '',

                    //尾款天
                    ldpayday: '',

                    //项目描述
                    projectDescription: '',

                    //终端成交价
                    zhongduanchengjiaojia: '',

                    //专营商毛利率
                    zhuanyingshangmaolilv: '',

                },


                //当前表信息
                tableData: [],


                //所有查到的计算回调信息
                alllastlist: [],


            };
        },

        //加载页面默认执行
        created() {

            console.log(this.$route.query,'this.$route.query')
            console.log(this.$route,'this.$route')

            //管理员
            this.guanliyuan = this.$store.getters.hasRole('swyl_admin');

            //财务
            this.caiwu = this.$store.getters.hasRole('swyl_shanghai_caiwu');


            this.jiazaigongshibiao();

            //this.getsongdachengshilist();

            // if (this.$route.query != null) {
                if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.ywid){

                //ywid
                this.ywid = this.$route.query.ywid;

                //instid
                this.instid = this.$route.query.instid;

                //taskid
                this.taskid = this.$route.query.taskid;

                this.taskstatus = this.$route.query.taskstatus;

                //计算版本
                this.rversion = this.$route.query.ywid;

                console.log(this.$route.query.ywid)

                //首次取值
                this.getconfigs(0, this.$route.query.ywid)

                // this.chazhaojisuanguocheng(this.proid);

                //存一个财务用来删除的版本id
                this.caiwuzhijiexiugaitijiaoshanchubanben = this.$route.query.ywid;

            }

                //特价查看跳转
                if(this.$route.query.chakanshiti && this.$route.query.chakanshiti!=''){

                    console.log(this.$route.query.chakanshiti,'this.$route.chakanshiti')

                    //只读
                    this.zhidumoshi = true;

                    //计算版本
                    this.rversion = this.$route.query.chakanshiti;

                    console.log(this.$route.query.chakanshiti,'this.$route.query.chakanshiti')

                    var rversion = {

                        rversion:this.$route.query.chakanshiti

                    }

                    //找版本判断instid
                    ss.FormulaNew.getbanben(rversion).then(rd => {

                        console.log(rd,'rdrdrdsssss')

                        //判断instid
                        this.panduaninstid(rd.obj);

                    })


                    //首次取值
                    this.getconfigs(0, this.$route.query.chakanshiti)

                }


        },

        mounted() {


        },

		directives: {
		  // 注册一个局部的自定义指令 v-focus
		  focus: {
		    // 指令的定义
		    inserted: function (el) {
		      // 聚焦元素
		      el.querySelector('input').focus()
		    }
		  }
		},
        methods: {
			clickjiage(item,index){
				console.log(item)
				item['flags' + parseInt(index)] = true;
                console.log(index,'indexindex')
                console.log(item,'itemitem')
                console.log(item['flags' + index],'item[\'flags\' + index]')
			},
			ldpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.ldpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}
			},
			mdpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.mdpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}
			},
			fdpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.fdpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}

			},
			pdpaychange(v){
				console.log(v)
				if(v == 1){
					this.ProMain.pdpay = 1;
					this.ProMain.fdpay = 0;
					this.ProMain.mdpay = 0;
					this.ProMain.ldpay = 0;
				}else{
					this.ProMain.fdpay = '';
					this.ProMain.mdpay = '';
					this.ProMain.ldpay = '';
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.pdpay = ''
					}else{
						console.log(v)
						return
					}
				}

			},


            //财务改数提交
            xiugaitijiao() {

                this.tijiaoagain(13);

            },

            //再次提交
            tijiaoagain(q) {

                //提交
                this.tongguoanniu(q);

            },


            caiwugaishula(row, zhi,index) {
				row['flags' + index] = false;
                console.log(row, zhi)

                for(var c = 1;c<16;c++){

                    if(row.canshuxulie!=null&&row.canshuxulie!=''&&row['xinghao'+c]!=null&&row['xinghao'+c]!=''&&row['xinghao'+c]==zhi){


                        console.log(this.baocuntable, 'baocuntable');

                        for (var d in this.baocuntable) {

                            if (this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] != zhi) {

                                row['shifougaishu' + c] = true;

                                this.beigaishude.push({

                                    c:c,
                                    xinghaoji: "shifougaishu" + c,
                                    flag: true,
                                    canshuxulie: row.canshuxulie,

                                })

                            }else if(this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] == zhi){

                                row['shifougaishu' + c] = false;

                                for(var f in this.beigaishude){

                                    if(this.beigaishude[f].canshuxulie==row.canshuxulie&&this.beigaishude[f].c==c){

                                        this.beigaishude[f].flag = false;

                                    }

                                }

                            }

                        }


                    }

                }

                console.log(this.beigaishude,'this.beigaishude')

            },

            kankanyichang() {

                this.jianchayichang = true;

            },

            jiazaigongshibiao() {

                ss.FormulaNew.gongshibiaolist().then(rd1 => {

                    this.gongshiduizhaobiao = '';

                    for (var c in rd1) {

                        if (rd1[c].type != 'w' && rd1[c].type != 'u') {

                            this.gongshiduizhaobiao += ("公式名: " + rd1[c].proName + (rd1[c].modelName != null && rd1[c].modelName != '' ? ("/" + rd1[c].modelName) : '') + (rd1[c].ratetext != null && rd1[c].ratetext != '' ? (" || 公式信息: " + rd1[c].ratetext) : "") + " || 公式编号: " + rd1[c].formulanum + (rd1[c].formula != null && rd1[c].formula != '' ? (" || 公式: " + rd1[c].formula) : '') + '\n' + '\n');

                        }

                    }

                })


            },


            gongshiduizhaokai() {

                this.gongshiduizhao = true;

            },

            xiangxixinxixianshi() {

                this.xiangxijilu = true;

            },

            jiazaijieguoxinxi(rd) {

                this.xiangxijilujieguo = '';

                this.yichangxinxi = '';

                for (var c in rd.jisuanjilu) {

                    this.xiangxijilujieguo += (c + rd.jisuanjilu[c] + '\n' + '\n');

                }

                this.yichangxinxi = rd.sb;

            },

            //获取送达城市
            // getsongdachengshilist() {

            //     ss.Dictservice.listbycategory("pscode_cesuan").then(rd => {

            //         this.songdachengshilist = rd;

            //     })

            // },

            // //选择使用人
            // shiyongrenxuanze(val) {
            //     console.log(val, '+++使用人')
            //     this.xuanzeren = false;
            //     this.ProMain.xuanzhongren = val.username;
            //     this.ProMain.shiyongren = val.usercode;

            // },

            // tanchuxuanzeren() {
            //     this.xuanzeren = true;
            //     // dialogFormVisible
            // },


            viewpress() {
                this.showhistory = true;
            },


            //财务计算按钮
            caiwujisuan() {

                this.jisuancishu++;

                console.log(this.jisuancishu,'this.jisuancishu')


                if (!((this.ispro == true ? this.ProMain.bid : true) && this.ProMain.bidway && this.ProMain.pdpay != null && this.ProMain.fdpay != null && this.ProMain.mdpay != null && this.ProMain.ldpay != null && this.ProMain.fdpayday != null && this.ProMain.mdpayday != null && this.ProMain.ldpayday != null)) {
                    this.$msg.msge("请先填写完整信息")
                } else {
                    this.getxiugaijieguo(99,2);
                }

            },


            // //返回上页
            // fanhuishangye(){
            //
            //     //跳转特价页面
            //     this.$router.push({path: '/pricenew'});
            //
            // },

            // chazhaojisuanguocheng(q){
            //
            //     var pid = {
            //
            //         proid:q
            //
            //     }
            //
            //     ss.FormulaNew.findguocheng(pid).then(rd => {
            //
            //         var num = 0;
            //         for(var i in rd.obj){
            //
            //             this.guochenglist.push(rd.obj[i])
            //
            //             console.log(i,'反正--------')
            //
            //             console.log(rd.obj[i],'---------反正')
            //
            //             console.log(i,'i.rversion')
            //
            //             var d = {
            //
            //                 value: i,
            //                 label:'版本 '+(num+1)+' 创建时间:'+this.$util.getyyyyMMdd(rd.obj[i]),
            //
            //             }
            //
            //             this.banbenop.push(d);
            //
            //             num++;
            //
            //         }
            //
            //
            //     })
            //
            //
            // },


            // //关闭选择框加载数据
            // gettable(){
            //
            //     this.query();
            //
            // },


            // //选没选值
            // xuanmeixuanzhi(done){
            //
            //     this.$confirm('确认关闭？')
            //         .then(_ => {
            //
            //             if(!this.banbenid){
            //                 this.$msg.msge('请先选择')
            //                 console.log('请先选择')
            //             }else{
            //
            //                 console.log(this.banbenid,'选中没')
            //
            //                 done();
            //
            //             }
            //
            //         })
            //         .catch(_ => {
            //
            //         });
            //
            // },


            //选择，将被选中存起来
            fuzhi(){

                console.log(this.banbenid,'看看选择的对不对')

                //计算版本
                this.rversion = this.banbenid;

            },


            // //提交去申请特价
            // tijiaoshenqingtejia(){
            //
            //     console.log(this.proid,'看看项目号')
            //
            //     //跳转特价页面
            //     this.$router.push({path: '/pricenew',query: {proid:this.proid}});
            //
            //
            // },


            con(i) {
                console.log(i)
            },
            getit() {
                return 1
            },
            dblclick(v, h, c, d) {
                console.log(v, h, c, d)
            },
            arraySpanMethod({row, column, rowIndex, columnIndex}) {
                if (rowIndex % 3 === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0) {
                    if (rowIndex === 0) {
                        return {
                            rowspan: 6,
                            colspan: 1
                        };
                    } else if (rowIndex === 6) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                        return {
                            rowspan: 7,
                            colspan: 1
                        };
                    } else if (rowIndex === 13) {
                        return {
                            rowspan: 3,
                            colspan: 1
                        }
                    } else if (rowIndex === 16) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        }
                    } else if (rowIndex === 20) {
                        return {
                            rowspan: 18,
                            colspan: 1
                        }
                    } else if (rowIndex === 38) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        }
                    } else if (rowIndex === 40) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        }
                    } else if (rowIndex === 44) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        }
                    } else if (rowIndex === 46) {
                        return {
                            rowspan: 15,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        }
                    }
                }
                if (columnIndex === 1) {
                    if (rowIndex === 22) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 23) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else if (rowIndex === 24) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 25) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else if (rowIndex === 31) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 32) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else if (rowIndex === 33) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 34) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else if (rowIndex === 35) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 36) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                }
                ;

            },


            // //查询翻页
            // query() {
            //
            //     ss.FormulaNew.selectPage(this.q).then(rd => {
            //
            //         this.q.total = rd.total;
            //
            //         this.xiangmuchanpinlist = rd.records;
            //
            //         console.log(this.xiangmuchanpinlist,'看看查到多少项目产品')
            //
            //
            //         if(this.shoucijiaohu){
            //
            //             //默认首次交互
            //             this.getconfigs(0);
            //
            //         }
            //
            //     })
            //
            // },


            // handleFilter() {
            //     this.q.pageNo = 1;
            //     this.query();
            // },


            // rules: {
            //     name: [
            //         {required: true, message: '请输入项目名称', trigger: 'blur'},
            //     ],
            // },


            //保修期选择方法
            repairchangetype(value) {
                console.log(value);
                console.log(this.repairtype);
            },


            //加载列
            addbiaotilie(listrd, allrate) {

                this.columndata = [];

                console.log(listrd)

                for (var c in listrd) {

                    console.log(c)

                    var cc = {

                        'prop': 'xinghao' + (new big(parseInt(c)).plus(1).toString()),
                        'label': '型号' + (new big(parseInt(c)).plus(1).toString()),
						'flagsindex': (new big(parseInt(c)).plus(1).toString()),

                    };


                    this.columndata.push(cc);


                }

                this.addshuju(listrd, allrate);

            },


            //加载列的数据
            addshuju(listrd, allrate) {
				console.log(listrd, allrate,"............................梁婕")
                this.alllastlist = [];

                //单页数据
                var csave = {};

                //遍历每个产品的单表
                for (var c in listrd) {
					for (var s in listrd[c]) {
						if (
							s == 'marcode'
							|| s == 'nonetypeLevel'
							|| s == 'opeLevel'
							|| s == 'productLevel'
							|| s == 'typeLevel'
                            || s == 'proProductInfoId'
						) {
							listrd[c][s] = listrd[c][s]
						}else{
							listrd[c][s] = parseFloat(listrd[c][s]) == '0'?'0':parseFloat(listrd[c][s]).toString()
						}
					}
                    //单页数据
                    csave = {

                        //项目产品id
                        "proProductInfoId": listrd[c].proProductInfoId == null ? "" : listrd[c].proProductInfoId,

                        //销量
                        "productNum": listrd[c].productNum == null ? "" : listrd[c].productNum,

                        //产品编码
                        "marcode": listrd[c].marcode == null ? "" : listrd[c].marcode,

                        //大类
                        "typeLevel": listrd[c].typeLevel == null ? "" : listrd[c].typeLevel,

                        //系列
                        "opeLevel": listrd[c].opeLevel == null ? "" : listrd[c].opeLevel,

                        //不知道是啥
                        "nonetypeLevel": listrd[c].nonetypeLevel == null ? "" : listrd[c].nonetypeLevel,

                        //产品型号
                        "productLevel": listrd[c].productLevel == null ? "" : listrd[c].productLevel,

                        //单台一级供价
                        "onemoney": listrd[c].onemoney == null ? "" : listrd[c].onemoney,

                        //专营商毛利率
                        "zhuanyingshangmaolilv": listrd[c].zhuanyingshangmaolilv == null ? "" : listrd[c].zhuanyingshangmaolilv,

                        //申请单价含税
                        "shenqingdanjia": listrd[c].shenqingdanjia == null ? "" : listrd[c].shenqingdanjia,

                        //折扣率
                        "zhekoulv": listrd[c].zhekoulv == null ? "" : listrd[c].zhekoulv,

                        //订单金额
                        "dingdanjine": listrd[c].dingdanjine == null ? "" : listrd[c].dingdanjine,

                        //不含税订单收入
                        "buhanshuishouru": listrd[c].buhanshuishouru == null ? "" : listrd[c].buhanshuishouru,

                        //单台成本
                        "dantaichengben": listrd[c].dantaichengben == null ? "" : listrd[c].dantaichengben,

                        //制造费用
                        "zhizaofeiyong": listrd[c].zhizaofeiyong == null ? "" : listrd[c].zhizaofeiyong,

                        //材料的制造费用率
                        "zhizaofeiyonglv": listrd[c].zhizaofeiyonglv == null ? "" : listrd[c].zhizaofeiyonglv,

                        //单台体积
                        "wuliufeiyongdanweitiji": listrd[c].wuliufeiyongdanweitiji == null ? "" : listrd[c].wuliufeiyongdanweitiji,

                        //单台安装费
                        "dantaianzhuangfei": listrd[c].dantaianzhuangfei == null ? "" : listrd[c].dantaianzhuangfei,

                        //安装费
                        "anzhuangfeianzhuangfei": listrd[c].anzhuangfeianzhuangfei == null ? "" : listrd[c].anzhuangfeianzhuangfei,

                        //维修基金
                        "weixiujijin": listrd[c].weixiujijin == null ? "" : listrd[c].weixiujijin,

                        //盈亏平衡含税价
                        "yingkuipingheng": listrd[c].yingkuipingheng == null ? "" : listrd[c].yingkuipingheng,

                        //材料毛利
                        "yinglicailiaomaoli": listrd[c].yinglicailiaomaoli == null ? "" : listrd[c].yinglicailiaomaoli,

                        //经营贡献
                        "jingyinggongxian": listrd[c].jingyinggongxian == null ? "" : listrd[c].jingyinggongxian,

                        //盈利 利润
                        "yinglilirun": listrd[c].yinglilirun == null ? "" : listrd[c].yinglilirun,

                        //毛利 成本合计
                        "maolichengbenheji": listrd[c].maolichengbenheji == null ? "" : listrd[c].maolichengbenheji,

                        //毛利 毛利
                        "maolimaoli": listrd[c].maolimaoli == null ? "" : listrd[c].maolimaoli,

                        //毛利 材料毛利率
                        "maolimaolilv": listrd[c].maolimaolilv == null ? "" : listrd[c].maolimaolilv,

                        //直接费用 物流费用 运费
                        "wuliufeiyongyunfei": listrd[c].wuliufeiyongyunfei == null ? "" : listrd[c].wuliufeiyongyunfei,

                        //直接费用 维修费  18年到产品实际费用
                        "zhijiefeiyongweixiufei": listrd[c].zhijiefeiyongweixiufei == null ? "" : listrd[c].zhijiefeiyongweixiufei,

                        //直接费用 备件费 18年到产品实际费用
                        "zhijiefeiyongbeijianfei": listrd[c].zhijiefeiyongbeijianfei == null ? "" : listrd[c].zhijiefeiyongbeijianfei,

                        //直接费用 退换机 18年到产品实际费用
                        "zhijiefeiyongtuihuanjifei": listrd[c].zhijiefeiyongtuihuanjifei == null ? "" : listrd[c].zhijiefeiyongtuihuanjifei,

                        //直接费用 退换机 18年到产品实际费用
                        "zijinchengben": listrd[c].zijinchengben == null ? "" : listrd[c].zijinchengben,

                        //中标服务费
                        "zhongbiaofuwufei": listrd[c].zhongbiaofuwufei == null ? "" : listrd[c].zhongbiaofuwufei,

                        //直接费用 税费 其他税费
                        "shuifeiqitashuifei": listrd[c].shuifeiqitashuifei == null ? "" : listrd[c].shuifeiqitashuifei,

                        //销售费用 销售人工
                        "xiaoshoufeiyongrengong": listrd[c].xiaoshoufeiyongrengong == null ? "" : listrd[c].xiaoshoufeiyongrengong,

                        //销售费用 销售组织运营
                        "xiaoshouzuzhiyunying": listrd[c].xiaoshouzuzhiyunying == null ? "" : listrd[c].xiaoshouzuzhiyunying,

                        //研发费用 研发人工
                        "yanfarengong": listrd[c].yanfarengong == null ? "" : listrd[c].yanfarengong,


                        //研发费用 研发组织运营
                        "yanfayunying": listrd[c].yanfayunying == null ? "" : listrd[c].yanfayunying,

                        //直接费用小计
                        "zhijiefeiyongxiaoji": listrd[c].zhijiefeiyongxiaoji == null ? "" : listrd[c].zhijiefeiyongxiaoji,

                        //经营贡献 经营贡献 经营贡献
                        "jingyinggongxiansan": listrd[c].jingyinggongxiansan == null ? "" : listrd[c].jingyinggongxiansan,

                        //经营贡献 经营贡献率 经营贡献率
                        "jingyinggongxianlv": listrd[c].jingyinggongxianlv == null ? "" : listrd[c].jingyinggongxianlv,

                        //平台费用 销售费用 自产费用率
                        "pingtaixiaoshoufeiyong": listrd[c].pingtaixiaoshoufeiyong == null ? "" : listrd[c].pingtaixiaoshoufeiyong,

                        //平台费用 管理费用 全部产品费用率
                        "pingtaiguanlifeiyong": listrd[c].pingtaiguanlifeiyong == null ? "" : listrd[c].pingtaiguanlifeiyong,

                        //平台费用 研发费用 自产研发费
                        "pingtaiyanfafeiyong": listrd[c].pingtaiyanfafeiyong == null ? "" : listrd[c].pingtaiyanfafeiyong,

                        //平台费用 平台费用小计
                        "pingtaifeiyongxiaoji": listrd[c].pingtaifeiyongxiaoji == null ? "" : listrd[c].pingtaifeiyongxiaoji,

                        //利润 利润  利润
                        "lirunsan": listrd[c].lirunsan == null ? "" : listrd[c].lirunsan,

                        //利润 利润率  利润率
                        "lirunlirunlv": listrd[c].lirunlirunlv == null ? "" : listrd[c].lirunlirunlv,

                        //附加成本  赠送耗材、周转机等成本 前台输入
                        "fujiachengben": listrd[c].fujiachengben == null ? "" : listrd[c].fujiachengben,

                        //终端成交价
                        "zhongduanchengjiaojia": listrd[c].zhongduanchengjiaojia == null ? "" : listrd[c].zhongduanchengjiaojia,

                        //损益表材料毛利率
                        "sunyibiaocailiaomaolilv": listrd[c].sunyibiaocailiaomaolilv == null ? "" : listrd[c].sunyibiaocailiaomaolilv,


                        //制造费用累计
                        "leijizhizao": listrd[c].leijizhizao == null ? "" : listrd[c].leijizhizao,


                        //材料成本累计
                        "leijichengben": listrd[c].leijichengben == null ? "" : listrd[c].leijichengben,


                        //单位运费-取自附表-国内物流费
                        "f5": listrd[c].f5 == null ? "" : listrd[c].f5,


                        //取自显示平台-产品损益表-国内维修费率-A02370
                        "f24": listrd[c].f24 == null ? "" : listrd[c].f24,


                        //产品损益表-国内备件费率
                        "f44": listrd[c].f44 == null ? "" : listrd[c].f44,


                        //费率取自附表-国内退换机
                        "f39": listrd[c].f39 == null ? "" : listrd[c].f39,


                        //取自显示平台-产品损益表，项目所属产品的国内税费-其他费率
                        "f41": listrd[c].f41 == null ? "" : listrd[c].f41,


                        //取自显示平台-产品损益表-项目所属产品的-国内销售-人工费率A02230
                        "f38": listrd[c].f38 == null ? "" : listrd[c].f38,


                        //费率取自显示平台_产品损益表_项目所属产品的-国内销售-组织运营费率
                        "f36": listrd[c].f36 == null ? "" : listrd[c].f36,


                        //费率取自显示平台-产品损益表-项目所属产品的国内-研发人工费率
                        "f43": listrd[c].f43 == null ? "" : listrd[c].f43,


                        //费率取自显示平台-产品损益表-项目所属产品的国内-研发组织运营费率-A02280
                        "f37": listrd[c].f37 == null ? "" : listrd[c].f37,


                        //费率取自显示平台-产品损益表，项目所属产品的国内-平台销售费用率-A02640
                        "f40": listrd[c].f40 == null ? "" : listrd[c].f40,


                        //费率取自显示平台-产品损益表，项目所属产品的国内-平台管理费用率-A02650
                        "f35": listrd[c].f35 == null ? "" : listrd[c].f35,


                        //费率取自显示平台-产品损益表，项目所属产品的国内-研发费用率-A02660
                        "f42": listrd[c].f42 == null ? "" : listrd[c].f42,


                    }

                    this.alllastlist.push(csave);


                    // this.ProMain.zhuanyingshangmaolilv = csave.zhuanyingshangmaolilv;

                }


                this.tableData = [{
                    message: '基本信息',
                    coding: '编码',
                    shuoming: '-',
                    biaozhun: '-',
                    hejiL: '-',
                    hejiE: '-',
					flags1: false,
					flags2: false,
					flags3: false,
					flags4: false,
					flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
                    xinghao1: this.alllastlist[0].marcode || '',
                    xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                    xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                    xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                    xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,

                    id1: this.alllastlist[0].proProductInfoId || '',
                    id2: this.alllastlist[1] == null ? '' : this.alllastlist[1].proProductInfoId,
                    id3: this.alllastlist[2] == null ? '' : this.alllastlist[2].proProductInfoId,
                    id4: this.alllastlist[3] == null ? '' : this.alllastlist[3].proProductInfoId,
                    id5: this.alllastlist[4] == null ? '' : this.alllastlist[4].proProductInfoId,
					id6: this.alllastlist[5] == null ? '' : this.alllastlist[5].proProductInfoId,
					id7: this.alllastlist[6] == null ? '' : this.alllastlist[6].proProductInfoId,
					id8: this.alllastlist[7] == null ? '' : this.alllastlist[7].proProductInfoId,
					id9: this.alllastlist[8] == null ? '' : this.alllastlist[8].proProductInfoId,
					id10: this.alllastlist[9] == null ? '' : this.alllastlist[9].proProductInfoId,
					id11: this.alllastlist[10] == null ? '' : this.alllastlist[10].proProductInfoId,
					id12: this.alllastlist[11] == null ? '' : this.alllastlist[11].proProductInfoId,
					id13: this.alllastlist[12] == null ? '' : this.alllastlist[12].proProductInfoId,
					id14: this.alllastlist[13] == null ? '' : this.alllastlist[13].proProductInfoId,
					id15: this.alllastlist[14] == null ? '' : this.alllastlist[14].proProductInfoId,
//0
                }, {
                    coding: '型号',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',
					flags1: false,
					flags2: false,
					flags3: false,
					flags4: false,
					flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
                    xinghao1: this.alllastlist[0].productLevel || '',
                    xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productLevel,
                    xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productLevel,
                    xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productLevel,
                    xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productLevel,
//1
                }, {
                    coding: '产品大类',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',
					flags1: false,
					flags2: false,
					flags3: false,
					flags4: false,
					flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
                    xinghao1: this.alllastlist[0].typeLevel || '',
                    xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].typeLevel,
                    xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].typeLevel,
                    xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].typeLevel,
                    xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].typeLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].typeLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].typeLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].typeLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].typeLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].typeLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].typeLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].typeLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].typeLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].typeLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].typeLevel,
//2
                }, {
                    coding: '产品系列',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',
					flags1: false,
					flags2: false,
					flags3: false,
					flags4: false,
					flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
                    xinghao1: this.alllastlist[0].opeLevel || '',
                    xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].opeLevel,
                    xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].opeLevel,
                    xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].opeLevel,
                    xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].opeLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].opeLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].opeLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].opeLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].opeLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].opeLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].opeLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].opeLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].opeLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].opeLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].opeLevel,
//3
                },
                    {
                        coding: '终端成交价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.zhongduanchengjiaojia || '',
                        canshu: 'zhongduanchengjiaojia',
                        xinghao1: this.alllastlist[0].zhongduanchengjiaojia || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhongduanchengjiaojia,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhongduanchengjiaojia,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhongduanchengjiaojia,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhongduanchengjiaojia,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhongduanchengjiaojia,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhongduanchengjiaojia,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhongduanchengjiaojia,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhongduanchengjiaojia,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhongduanchengjiaojia,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhongduanchengjiaojia,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhongduanchengjiaojia,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhongduanchengjiaojia,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhongduanchengjiaojia,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhongduanchengjiaojia,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie2: 'zhongduanchengjiaojia',
//4
                    },
                    {
                        coding: '专营商毛利率',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 'g4',
                        hejiE: allrate.zhuanyingshangmaolilv || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].zhuanyingshangmaolilv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhuanyingshangmaolilv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhuanyingshangmaolilv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhuanyingshangmaolilv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhuanyingshangmaolilv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhuanyingshangmaolilv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhuanyingshangmaolilv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhuanyingshangmaolilv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhuanyingshangmaolilv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhuanyingshangmaolilv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhuanyingshangmaolilv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhuanyingshangmaolilv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhuanyingshangmaolilv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhuanyingshangmaolilv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhuanyingshangmaolilv,
                        canshuxulie2: 'zhuanyingshangmaolilv',
//5
                    }, {
                        message: '收入',
                        coding: '单台一级供价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 'f45',
                        hejiE: allrate.onemoney || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].onemoney || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].onemoney,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].onemoney,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].onemoney,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].onemoney,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].onemoney,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].onemoney,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].onemoney,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].onemoney,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].onemoney,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].onemoney,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].onemoney,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].onemoney,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].onemoney,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].onemoney,
                        canshuxulie2: 'onemoney',
//6
                    }, {
                        coding: '折扣率',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 'g5',
                        hejiE: allrate.zhekoulv || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].zhekoulv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhekoulv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhekoulv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhekoulv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhekoulv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhekoulv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhekoulv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhekoulv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhekoulv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhekoulv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhekoulv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhekoulv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhekoulv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhekoulv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhekoulv,
                        canshuxulie2: 'zhekoulv',
//7
                    },
                    {
                        coding: '销量',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 's6',
                        hejiE: allrate.productNum || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].productNum || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productNum,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productNum,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productNum,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productNum,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productNum,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productNum,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productNum,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productNum,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productNum,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productNum,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productNum,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productNum,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productNum,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productNum,
                        canshuxulie2: 'productNum',
//8
                    },
                    {
                        coding: '申请单价(含税)',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 's17',
                        hejiE: allrate.shenqingdanjia || '',
                        canshu: 'shenqingdanjia',
                        xinghao1: this.alllastlist[0].shenqingdanjia || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shenqingdanjia,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shenqingdanjia,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shenqingdanjia,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shenqingdanjia,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shenqingdanjia,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shenqingdanjia,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shenqingdanjia,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shenqingdanjia,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shenqingdanjia,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shenqingdanjia,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shenqingdanjia,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shenqingdanjia,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shenqingdanjia,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shenqingdanjia,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie2: 'shenqingdanjia',
//9
                    },
                    {
                        coding: '订单金额',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 'g6',
                        hejiE: allrate.dingdanjine || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].dingdanjine || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dingdanjine,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dingdanjine,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dingdanjine,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dingdanjine,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dingdanjine,
                        canshuxulie2: 'dingdanjine',
//10
                    },
                    {
                        coding: '不含税订单收入',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 'g7',
                        hejiE: allrate.buhanshuishouru || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].buhanshuishouru || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].buhanshuishouru,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].buhanshuishouru,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].buhanshuishouru,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].buhanshuishouru,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].buhanshuishouru,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].buhanshuishouru,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].buhanshuishouru,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].buhanshuishouru,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].buhanshuishouru,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].buhanshuishouru,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].buhanshuishouru,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].buhanshuishouru,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].buhanshuishouru,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].buhanshuishouru,
                        canshuxulie2: 'buhanshuishouru',
//11
                    },
                    {
                        coding: '盈亏平衡含税价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        canshuxulie: 't3',
                        hejiE: allrate.yingkuipingheng || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].yingkuipingheng || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yingkuipingheng,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yingkuipingheng,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yingkuipingheng,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yingkuipingheng,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yingkuipingheng,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yingkuipingheng,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yingkuipingheng,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yingkuipingheng,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yingkuipingheng,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yingkuipingheng,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yingkuipingheng,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yingkuipingheng,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yingkuipingheng,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yingkuipingheng,
                        canshuxulie2: 'yingkuipingheng',
//12
                    },
                    {
                        message: '盈利情况',
                        coding: '材料毛利',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.yinglicailiaomaoli == null || allrate.yinglicailiaomaoli == '' || allrate.yinglicailiaomaoli == 0 || allrate.yinglicailiaomaoli == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yinglicailiaomaoli)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        canshuxulie: 'g8',
                        hejiE: allrate.yinglicailiaomaoli || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].yinglicailiaomaoli || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglicailiaomaoli,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglicailiaomaoli,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglicailiaomaoli,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglicailiaomaoli,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglicailiaomaoli,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglicailiaomaoli,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglicailiaomaoli,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglicailiaomaoli,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglicailiaomaoli,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglicailiaomaoli,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglicailiaomaoli,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglicailiaomaoli,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglicailiaomaoli,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglicailiaomaoli,
                        canshuxulie2: 'yinglicailiaomaoli',
//13
                    },
                    {
                        coding: '经营贡献',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.jingyinggongxian == null || allrate.jingyinggongxian == '' || allrate.jingyinggongxian == 0 || allrate.jingyinggongxian == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.jingyinggongxian)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't4',
                        hejiE: allrate.jingyinggongxian || '',

                        xinghao1: this.alllastlist[0].jingyinggongxian || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxian,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxian,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxian,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxian,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxian,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxian,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxian,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxian,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxian,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxian,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxian,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxian,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxian,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxian,
                        canshuxulie2: 'jingyinggongxian',
//14
                    },
                    {
                        coding: '利润',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.yinglilirun == null || allrate.yinglilirun == '' || allrate.yinglilirun == 0 || allrate.yinglilirun == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yinglilirun)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't5',
                        hejiE: allrate.yinglilirun || '',

                        xinghao1: this.alllastlist[0].yinglilirun || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglilirun,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglilirun,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglilirun,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglilirun,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglilirun,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglilirun,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglilirun,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglilirun,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglilirun,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglilirun,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglilirun,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglilirun,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglilirun,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglilirun,
                        canshuxulie2: 'yinglilirun',
//15
                    },
                    {
                        message: '毛利',
                        coding: '单台成本',
                        shuoming: '测算当月BOM成本',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 'f48',
                        hejiE: allrate.dantaichengben || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].dantaichengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaichengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaichengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaichengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaichengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaichengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaichengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaichengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaichengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaichengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaichengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaichengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaichengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaichengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaichengben,
                        canshuxulie2: 'dantaichengben',
//16
                    },
                    {
                        coding: '成本合计',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.maolichengbenheji == null || allrate.maolichengbenheji == '' || allrate.maolichengbenheji == 0 || allrate.maolichengbenheji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.maolichengbenheji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',

                        canshuxulie: 'g9',
                        hejiE: allrate.maolichengbenheji || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].maolichengbenheji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolichengbenheji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolichengbenheji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolichengbenheji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolichengbenheji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolichengbenheji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolichengbenheji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolichengbenheji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolichengbenheji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolichengbenheji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolichengbenheji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolichengbenheji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolichengbenheji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolichengbenheji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolichengbenheji,
                        canshuxulie2: 'maolichengbenheji',
//17
                    },
                    {
                        coding: '毛利',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.maolimaoli == null || allrate.maolimaoli == '' || allrate.maolimaoli == 0 || allrate.maolimaoli == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.maolimaoli)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g10',
                        hejiE: allrate.maolimaoli || '',

                        xinghao1: this.alllastlist[0].maolimaoli || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaoli,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaoli,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaoli,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaoli,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaoli,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaoli,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaoli,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaoli,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaoli,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaoli,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaoli,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaoli,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaoli,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaoli,
                        canshuxulie2: 'maolimaoli',
//18
                    },
                    {
                        coding: '材料毛利率',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 'g11',
                        shuoming: '-',
                        hejiE: allrate.maolimaolilv || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].maolimaolilv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaolilv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaolilv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaolilv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaolilv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaolilv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaolilv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaolilv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaolilv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaolilv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaolilv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaolilv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaolilv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaolilv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaolilv,
                        canshuxulie2: 'maolimaolilv',
//19
                    },
                    {
                        message: '直接费用',
                        coding: '制造费用',
                        shuoming: '材料的制造费用率',
                        biaozhun: '-',
                        hejiL: ((allrate.zhizaofeiyong == null || allrate.zhizaofeiyong == '' || allrate.zhizaofeiyong == 0 || allrate.zhizaofeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhizaofeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g12',
                        hejiE: allrate.zhizaofeiyong || '',

                        xinghao1: this.alllastlist[0].zhizaofeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhizaofeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhizaofeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhizaofeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhizaofeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhizaofeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhizaofeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhizaofeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhizaofeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhizaofeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhizaofeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhizaofeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhizaofeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhizaofeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhizaofeiyong,
                        canshuxulie2: 'zhizaofeiyong',
//20
                    },
                    {
                        message: '直接费用',
                        coding: '附加成本',
                        shuoming: '赠送耗材、周转机等成本',
                        biaozhun: '-',
                        hejiL: ((allrate.fujiachengben == null || allrate.fujiachengben == '' || allrate.fujiachengben == 0 || allrate.fujiachengben == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.fujiachengben)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 's14',
                        hejiE: allrate.fujiachengben || '',
                        canshu: 'fujiachengben',
                        xinghao1: this.alllastlist[0].fujiachengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].fujiachengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].fujiachengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].fujiachengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].fujiachengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].fujiachengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].fujiachengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].fujiachengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].fujiachengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].fujiachengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].fujiachengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].fujiachengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].fujiachengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].fujiachengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].fujiachengben,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie2: 'fujiachengben',
//21
                    },
                    {
                        coding: '物流费用',
                        shuoming: '单位体积',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 'f46',
                        hejiE: allrate.wuliufeiyongdanweitiji || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].wuliufeiyongdanweitiji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongdanweitiji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongdanweitiji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongdanweitiji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongdanweitiji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongdanweitiji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongdanweitiji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongdanweitiji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongdanweitiji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongdanweitiji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongdanweitiji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongdanweitiji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongdanweitiji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongdanweitiji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongdanweitiji,
                        canshuxulie2: 'wuliufeiyongdanweitiji',
//22
                    },
                    {
                        coding: '-',
                        shuoming: '运费',
                        biaozhun: '-',
                        hejiL: ((allrate.wuliufeiyongyunfei == null || allrate.wuliufeiyongyunfei == '' || allrate.wuliufeiyongyunfei == 0 || allrate.wuliufeiyongyunfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.wuliufeiyongyunfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',

                        canshuxulie: 'g13',
                        hejiE: allrate.wuliufeiyongyunfei || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].wuliufeiyongyunfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongyunfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongyunfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongyunfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongyunfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongyunfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongyunfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongyunfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongyunfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongyunfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongyunfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongyunfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongyunfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongyunfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongyunfei,
                        canshuxulie2: 'wuliufeiyongyunfei',
//23
                    },
                    {
                        coding: '安装费用',
                        shuoming: '单台安装费',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 'f50',
                        hejiE: allrate.dantaianzhuangfei || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].dantaianzhuangfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaianzhuangfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaianzhuangfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaianzhuangfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaianzhuangfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaianzhuangfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaianzhuangfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaianzhuangfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaianzhuangfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaianzhuangfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaianzhuangfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaianzhuangfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaianzhuangfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaianzhuangfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaianzhuangfei,
                        canshuxulie2: 'dantaianzhuangfei',
//24
                    },
                    {
                        coding: '-',
                        shuoming: '安装费',
                        biaozhun: '-',
                        hejiL: ((allrate.anzhuangfeianzhuangfei == null || allrate.anzhuangfeianzhuangfei == '' || allrate.anzhuangfeianzhuangfei == 0 || allrate.anzhuangfeianzhuangfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.anzhuangfeianzhuangfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',

                        canshuxulie: 'g14',
                        hejiE: allrate.anzhuangfeianzhuangfei || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].anzhuangfeianzhuangfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].anzhuangfeianzhuangfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].anzhuangfeianzhuangfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].anzhuangfeianzhuangfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].anzhuangfeianzhuangfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].anzhuangfeianzhuangfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].anzhuangfeianzhuangfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].anzhuangfeianzhuangfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].anzhuangfeianzhuangfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].anzhuangfeianzhuangfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].anzhuangfeianzhuangfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].anzhuangfeianzhuangfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].anzhuangfeianzhuangfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].anzhuangfeianzhuangfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].anzhuangfeianzhuangfei,
                        canshuxulie2: 'anzhuangfeianzhuangfei',
//25
                    },
                    {
                        coding: '维修费',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongweixiufei == null || allrate.zhijiefeiyongweixiufei == '' || allrate.zhijiefeiyongweixiufei == 0 || allrate.zhijiefeiyongweixiufei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongweixiufei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g15',
                        hejiE: allrate.zhijiefeiyongweixiufei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongweixiufei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongweixiufei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongweixiufei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongweixiufei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongweixiufei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongweixiufei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongweixiufei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongweixiufei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongweixiufei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongweixiufei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongweixiufei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongweixiufei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongweixiufei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongweixiufei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongweixiufei,
                        canshuxulie2: 'zhijiefeiyongweixiufei',
//26
                    },
                    {
                        coding: '备件费',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongbeijianfei == null || allrate.zhijiefeiyongbeijianfei == '' || allrate.zhijiefeiyongbeijianfei == 0 || allrate.zhijiefeiyongbeijianfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongbeijianfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g16',
                        hejiE: allrate.zhijiefeiyongbeijianfei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongbeijianfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongbeijianfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongbeijianfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongbeijianfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongbeijianfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongbeijianfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongbeijianfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongbeijianfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongbeijianfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongbeijianfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongbeijianfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongbeijianfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongbeijianfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongbeijianfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongbeijianfei,
                        canshuxulie2: 'zhijiefeiyongbeijianfei',
//27
                    },
                    {
                        coding: '退换机',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongtuihuanjifei == null || allrate.zhijiefeiyongtuihuanjifei == '' || allrate.zhijiefeiyongtuihuanjifei == 0 || allrate.zhijiefeiyongtuihuanjifei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongtuihuanjifei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g17',
                        hejiE: allrate.zhijiefeiyongtuihuanjifei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongtuihuanjifei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongtuihuanjifei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongtuihuanjifei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongtuihuanjifei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongtuihuanjifei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongtuihuanjifei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongtuihuanjifei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongtuihuanjifei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongtuihuanjifei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongtuihuanjifei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongtuihuanjifei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongtuihuanjifei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongtuihuanjifei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongtuihuanjifei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongtuihuanjifei,
                        canshuxulie2: 'zhijiefeiyongtuihuanjifei',
//28
                    },
                    {
                        coding: '资金成本',
                        shuoming: '资金成本损失',
                        biaozhun: '-',
                        hejiL: ((allrate.zijinchengben == null || allrate.zijinchengben == '' || allrate.zijinchengben == 0 || allrate.zijinchengben == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zijinchengben)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g18',
                        hejiE: allrate.zijinchengben || '',

                        xinghao1: this.alllastlist[0].zijinchengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zijinchengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zijinchengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zijinchengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zijinchengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zijinchengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zijinchengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zijinchengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zijinchengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zijinchengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zijinchengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zijinchengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zijinchengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zijinchengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zijinchengben,
                        canshuxulie2: 'zijinchengben',
//29
                    },
                    {
                        coding: '中标服务费',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.zhongbiaofuwufei == null || allrate.zhongbiaofuwufei == '' || allrate.zhongbiaofuwufei == 0 || allrate.zhongbiaofuwufei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhongbiaofuwufei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 's3',
                        hejiE: allrate.zhongbiaofuwufei || '',
                        canshu: 'zhongbiaofuwufei',
                        xinghao1: this.alllastlist[0].zhongbiaofuwufei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhongbiaofuwufei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhongbiaofuwufei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhongbiaofuwufei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhongbiaofuwufei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhongbiaofuwufei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhongbiaofuwufei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhongbiaofuwufei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhongbiaofuwufei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhongbiaofuwufei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhongbiaofuwufei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhongbiaofuwufei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhongbiaofuwufei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhongbiaofuwufei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhongbiaofuwufei,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie2: 'zhongbiaofuwufei',
//30
                    },

                    {
                        coding: '税费',
                        shuoming: '维修基金',
                        biaozhun: '-',
                        hejiL: ((allrate.weixiujijin == null || allrate.weixiujijin == '' || allrate.weixiujijin == 0 || allrate.weixiujijin == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.weixiujijin)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't6',
                        hejiE: allrate.weixiujijin || '',

                        xinghao1: this.alllastlist[0].weixiujijin || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].weixiujijin,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].weixiujijin,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].weixiujijin,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].weixiujijin,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].weixiujijin,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].weixiujijin,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].weixiujijin,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].weixiujijin,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].weixiujijin,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].weixiujijin,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].weixiujijin,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].weixiujijin,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].weixiujijin,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].weixiujijin,
                        canshuxulie2: 'weixiujijin',
//31
                    },
                    {
                        coding: '-',
                        shuoming: '其他税费',
                        biaozhun: '-',
                        hejiL: ((allrate.shuifeiqitashuifei == null || allrate.shuifeiqitashuifei == '' || allrate.shuifeiqitashuifei == 0 || allrate.shuifeiqitashuifei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.shuifeiqitashuifei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',

                        canshuxulie: 'g20',
                        hejiE: allrate.shuifeiqitashuifei || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].shuifeiqitashuifei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shuifeiqitashuifei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shuifeiqitashuifei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shuifeiqitashuifei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shuifeiqitashuifei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shuifeiqitashuifei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shuifeiqitashuifei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shuifeiqitashuifei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shuifeiqitashuifei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shuifeiqitashuifei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shuifeiqitashuifei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shuifeiqitashuifei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shuifeiqitashuifei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shuifeiqitashuifei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shuifeiqitashuifei,
                        canshuxulie2: 'shuifeiqitashuifei',
//32
                    },

                    {
                        coding: '销售费用',
                        shuoming: '销售人工',
                        biaozhun: '-',
                        hejiL: ((allrate.xiaoshoufeiyongrengong == null || allrate.xiaoshoufeiyongrengong == '' || allrate.xiaoshoufeiyongrengong == 0 || allrate.xiaoshoufeiyongrengong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.xiaoshoufeiyongrengong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',

                        canshuxulie: 'g21',
                        hejiE: allrate.xiaoshoufeiyongrengong || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: this.alllastlist[0].xiaoshoufeiyongrengong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshoufeiyongrengong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshoufeiyongrengong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshoufeiyongrengong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshoufeiyongrengong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshoufeiyongrengong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshoufeiyongrengong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshoufeiyongrengong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshoufeiyongrengong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshoufeiyongrengong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshoufeiyongrengong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshoufeiyongrengong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshoufeiyongrengong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshoufeiyongrengong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshoufeiyongrengong,
                        canshuxulie2: 'xiaoshoufeiyongrengong',
//33
                    },
                    {
                        coding: '-',
                        shuoming: '销售组织运营',
                        biaozhun: '-',
                        hejiL: ((allrate.xiaoshouzuzhiyunying == null || allrate.xiaoshouzuzhiyunying == '' || allrate.xiaoshouzuzhiyunying == 0 || allrate.xiaoshouzuzhiyunying == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.xiaoshouzuzhiyunying)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g22',
                        hejiE: allrate.xiaoshouzuzhiyunying || '',

                        xinghao1: this.alllastlist[0].xiaoshouzuzhiyunying || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshouzuzhiyunying,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshouzuzhiyunying,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshouzuzhiyunying,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshouzuzhiyunying,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshouzuzhiyunying,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshouzuzhiyunying,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshouzuzhiyunying,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshouzuzhiyunying,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshouzuzhiyunying,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshouzuzhiyunying,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshouzuzhiyunying,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshouzuzhiyunying,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshouzuzhiyunying,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshouzuzhiyunying,
                        canshuxulie2: 'xiaoshouzuzhiyunying',
//34
                    },
                    {
                        coding: '研发费用',
                        shuoming: '研发人工',
                        biaozhun: '-',
                        hejiL: ((allrate.yanfarengong == null || allrate.yanfarengong == '' || allrate.yanfarengong == 0 || allrate.yanfarengong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yanfarengong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g23',
                        hejiE: allrate.yanfarengong || '',

                        xinghao1: this.alllastlist[0].yanfarengong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfarengong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfarengong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfarengong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfarengong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfarengong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfarengong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfarengong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfarengong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfarengong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfarengong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfarengong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfarengong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfarengong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfarengong,
                        canshuxulie2: 'yanfarengong',
//35
                    },
                    {
                        coding: '-',
                        shuoming: '研发组织运营',
                        biaozhun: '-',
                        hejiL: ((allrate.yanfayunying == null || allrate.yanfayunying == '' || allrate.yanfayunying == 0 || allrate.yanfayunying == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yanfayunying)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g24',
                        hejiE: allrate.yanfayunying || '',

                        xinghao1: this.alllastlist[0].yanfayunying || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfayunying,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfayunying,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfayunying,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfayunying,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfayunying,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfayunying,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfayunying,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfayunying,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfayunying,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfayunying,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfayunying,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfayunying,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfayunying,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfayunying,
                        canshuxulie2: 'yanfayunying',
//36
                    },
                    {
                        coding: '直接费用小计',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongxiaoji == null || allrate.zhijiefeiyongxiaoji == '' || allrate.zhijiefeiyongxiaoji == 0 || allrate.zhijiefeiyongxiaoji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongxiaoji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't7',
                        hejiE: allrate.zhijiefeiyongxiaoji || '',
                        xinghao1: this.alllastlist[0].zhijiefeiyongxiaoji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongxiaoji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongxiaoji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongxiaoji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongxiaoji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongxiaoji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongxiaoji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongxiaoji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongxiaoji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongxiaoji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongxiaoji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongxiaoji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongxiaoji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongxiaoji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongxiaoji,
                        canshuxulie2: 'zhijiefeiyongxiaoji',
//37
                    },
                    {
                        message: '经营贡献',
                        coding: '经营贡献',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.jingyinggongxiansan == null || allrate.jingyinggongxiansan == '' || allrate.jingyinggongxiansan == 0 || allrate.jingyinggongxiansan == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.jingyinggongxiansan)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't8',
                        hejiE: allrate.jingyinggongxiansan || '',
                        xinghao1: this.alllastlist[0].jingyinggongxiansan || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxiansan,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxiansan,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxiansan,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxiansan,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxiansan,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxiansan,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxiansan,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxiansan,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxiansan,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxiansan,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxiansan,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxiansan,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxiansan,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxiansan,
                        canshuxulie2: 'jingyinggongxiansan',
//38
                    },
                    {
                        coding: '经营贡献率',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't9',
                        hejiE: allrate.jingyinggongxianlv || '',
                        xinghao1: this.alllastlist[0].jingyinggongxianlv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxianlv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxianlv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxianlv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxianlv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxianlv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxianlv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxianlv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxianlv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxianlv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxianlv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxianlv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxianlv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxianlv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxianlv,
                        canshuxulie2: 'jingyinggongxianlv',
//39
                    },
                    {
                        message: '平台费用',
                        coding: '销售费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaixiaoshoufeiyong == null || allrate.pingtaixiaoshoufeiyong == '' || allrate.pingtaixiaoshoufeiyong == 0 || allrate.pingtaixiaoshoufeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaixiaoshoufeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g25',
                        hejiE: allrate.pingtaixiaoshoufeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaixiaoshoufeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaixiaoshoufeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaixiaoshoufeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaixiaoshoufeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaixiaoshoufeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaixiaoshoufeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaixiaoshoufeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaixiaoshoufeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaixiaoshoufeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaixiaoshoufeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaixiaoshoufeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaixiaoshoufeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaixiaoshoufeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaixiaoshoufeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaixiaoshoufeiyong,
                        canshuxulie2: 'pingtaixiaoshoufeiyong',
//40
                    },
                    {
                        coding: '管理费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaiguanlifeiyong == null || allrate.pingtaiguanlifeiyong == '' || allrate.pingtaiguanlifeiyong == 0 || allrate.pingtaiguanlifeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaiguanlifeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g26',
                        hejiE: allrate.pingtaiguanlifeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaiguanlifeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiguanlifeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiguanlifeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiguanlifeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiguanlifeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiguanlifeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiguanlifeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiguanlifeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiguanlifeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiguanlifeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiguanlifeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiguanlifeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiguanlifeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiguanlifeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiguanlifeiyong,
                        canshuxulie2: 'pingtaiguanlifeiyong',
//41
                    },
                    {
                        coding: '研发费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaiyanfafeiyong == null || allrate.pingtaiyanfafeiyong == '' || allrate.pingtaiyanfafeiyong == 0 || allrate.pingtaiyanfafeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaiyanfafeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g27',
                        hejiE: allrate.pingtaiyanfafeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaiyanfafeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiyanfafeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiyanfafeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiyanfafeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiyanfafeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiyanfafeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiyanfafeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiyanfafeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiyanfafeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiyanfafeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiyanfafeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiyanfafeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiyanfafeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiyanfafeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiyanfafeiyong,
                        canshuxulie2: 'pingtaiyanfafeiyong',
//42
                    },
                    {
                        coding: '平台费用小计',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaifeiyongxiaoji == null || allrate.pingtaifeiyongxiaoji == '' || allrate.pingtaifeiyongxiaoji == 0 || allrate.pingtaifeiyongxiaoji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaifeiyongxiaoji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 'g28',
                        hejiE: allrate.pingtaifeiyongxiaoji || '',
                        xinghao1: this.alllastlist[0].pingtaifeiyongxiaoji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaifeiyongxiaoji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaifeiyongxiaoji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaifeiyongxiaoji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaifeiyongxiaoji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaifeiyongxiaoji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaifeiyongxiaoji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaifeiyongxiaoji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaifeiyongxiaoji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaifeiyongxiaoji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaifeiyongxiaoji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaifeiyongxiaoji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaifeiyongxiaoji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaifeiyongxiaoji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaifeiyongxiaoji,
                        canshuxulie2: 'pingtaifeiyongxiaoji',
//43
                    },
                    {
                        message: '利润',
                        coding: '利润',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.lirunsan == null || allrate.lirunsan == '' || allrate.lirunsan == 0 || allrate.lirunsan == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.lirunsan)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        canshuxulie: 't10',
                        hejiE: allrate.lirunsan || '',
                        xinghao1: this.alllastlist[0].lirunsan || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunsan,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunsan,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunsan,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunsan,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunsan,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunsan,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunsan,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunsan,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunsan,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunsan,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunsan,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunsan,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunsan,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunsan,
                        canshuxulie2: 'lirunsan',
//44
                    },
                    {
                        coding: '利润率',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 't11',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.lirunlirunlv || '',
                        xinghao1: this.alllastlist[0].lirunlirunlv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunlirunlv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunlirunlv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunlirunlv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunlirunlv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunlirunlv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunlirunlv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunlirunlv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunlirunlv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunlirunlv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunlirunlv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunlirunlv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunlirunlv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunlirunlv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunlirunlv,
                        canshuxulie2: 'lirunlirunlv',
//45
                    },

                    {
                        message: '其他计算参数',
                        coding: '损益平台制造费用累计',
                        shuoming: 'leijizhizao',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.leijizhizao || '',
                        xinghao1: this.alllastlist[0].leijizhizao || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].leijizhizao,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].leijizhizao,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].leijizhizao,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].leijizhizao,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].leijizhizao,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].leijizhizao,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].leijizhizao,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].leijizhizao,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].leijizhizao,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].leijizhizao,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].leijizhizao,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].leijizhizao,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].leijizhizao,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].leijizhizao,
                        canshuxulie2: 'leijizhizao',
//46
                    },

                    {
                        coding: '损益平台材料成本累计',
                        shuoming: 'leijichengben',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.leijichengben || '',
                        xinghao1: this.alllastlist[0].leijichengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].leijichengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].leijichengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].leijichengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].leijichengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].leijichengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].leijichengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].leijichengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].leijichengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].leijichengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].leijichengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].leijichengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].leijichengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].leijichengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].leijichengben,
                        canshuxulie2: 'leijichengben',
//47
                    },

                    {
                        coding: '单位运费-取自附表-国内物流费',
                        shuoming: 'f5',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f5 || '',
                        xinghao1: this.alllastlist[0].f5 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f5,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f5,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f5,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f5,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f5,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f5,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f5,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f5,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f5,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f5,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f5,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f5,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f5,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f5,
                        canshuxulie2: 'f5',
//48
                    },

                    {
                        coding: '取自显示平台-产品损益表-国内维修费率-A02370',
                        shuoming: 'f24',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f24 || '',
                        xinghao1: this.alllastlist[0].f24 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f24,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f24,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f24,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f24,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f24,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f24,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f24,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f24,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f24,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f24,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f24,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f24,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f24,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f24,
                        canshuxulie2: 'f24',
//49
                    },

                    {
                        coding: '产品损益表-国内备件费率',
                        shuoming: 'f44',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f44 || '',
                        xinghao1: this.alllastlist[0].f44 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f44,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f44,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f44,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f44,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f44,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f44,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f44,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f44,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f44,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f44,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f44,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f44,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f44,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f44,
                        canshuxulie2: 'f44',
//50
                    },

                    {
                        coding: '费率取自附表-国内退换机',
                        shuoming: 'f39',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f39 || '',
                        xinghao1: this.alllastlist[0].f39 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f39,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f39,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f39,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f39,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f39,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f39,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f39,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f39,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f39,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f39,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f39,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f39,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f39,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f39,
                        canshuxulie2: 'f39',
//51
                    },

                    {
                        coding: '取自显示平台-产品损益表，项目所属产品的国内税费-其他费率',
                        shuoming: 'f41',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f41 || '',
                        xinghao1: this.alllastlist[0].f41 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f41,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f41,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f41,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f41,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f41,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f41,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f41,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f41,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f41,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f41,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f41,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f41,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f41,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f41,
                        canshuxulie2: 'f41',
//52
                    },

                    {
                        coding: '取自显示平台-产品损益表-项目所属产品的-国内销售-人工费率A02230',
                        shuoming: 'f38',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f38 || '',
                        xinghao1: this.alllastlist[0].f38 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f38,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f38,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f38,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f38,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f38,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f38,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f38,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f38,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f38,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f38,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f38,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f38,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f38,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f38,
                        canshuxulie2: 'f38',
//53
                    },

                    {
                        coding: '费率取自显示平台_产品损益表_项目所属产品的-国内销售-组织运营费率',
                        shuoming: 'f36',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f36 || '',
                        xinghao1: this.alllastlist[0].f36 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f36,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f36,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f36,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f36,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f36,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f36,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f36,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f36,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f36,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f36,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f36,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f36,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f36,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f36,
                        canshuxulie2: 'f36',
//54
                    },

                    {
                        coding: '费率取自显示平台-产品损益表-项目所属产品的国内-研发人工费率',
                        shuoming: 'f43',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f43 || '',
                        xinghao1: this.alllastlist[0].f43 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f43,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f43,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f43,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f43,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f43,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f43,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f43,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f43,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f43,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f43,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f43,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f43,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f43,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f43,
                        canshuxulie2: 'f43',
//55
                    },

                    {
                        coding: '费率取自显示平台-产品损益表-项目所属产品的国内-研发组织运营费率-A02280',
                        shuoming: 'f37',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f37 || '',
                        xinghao1: this.alllastlist[0].f37 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f37,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f37,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f37,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f37,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f37,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f37,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f37,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f37,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f37,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f37,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f37,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f37,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f37,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f37,
                        canshuxulie2: 'f37',
//56
                    },

                    {
                        coding: '费率取自显示平台-产品损益表，项目所属产品的国内-平台销售费用率-A02640',
                        shuoming: 'f40',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f40 || '',
                        xinghao1: this.alllastlist[0].f40 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f40,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f40,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f40,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f40,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f40,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f40,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f40,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f40,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f40,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f40,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f40,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f40,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f40,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f40,
                        canshuxulie2: 'f40',
//57
                    },

                    {
                        coding: '费率取自显示平台-产品损益表，项目所属产品的国内-平台管理费用率-A02650',
                        shuoming: 'f35',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f35 || '',
                        xinghao1: this.alllastlist[0].f35 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f35,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f35,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f35,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f35,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f35,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f35,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f35,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f35,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f35,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f35,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f35,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f35,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f35,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f35,
                        canshuxulie2: 'f35',
//58
                    },

                    {
                        coding: '费率取自显示平台-产品损益表，项目所属产品的国内-研发费用率-A02660',
                        shuoming: 'f42',
                        biaozhun: '-',
                        hejiL: '-',
						flags1: false,
						flags2: false,
						flags3: false,
						flags4: false,
						flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.f42 || '',
                        xinghao1: this.alllastlist[0].f42 || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].f42,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].f42,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].f42,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].f42,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].f42,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].f42,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].f42,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].f42,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].f42,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].f42,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].f42,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].f42,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].f42,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].f42,
                        canshuxulie2: 'f42',
//59
                    },

                    {
                        coding: '材料的制造费用率',
                        shuoming: 'zhizaofeiyonglv',
                        biaozhun: '-',
                        hejiL: '-',
                        canshuxulie: 'f3',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        hejiE: allrate.zhizaofeiyonglv || '',
                        xinghao1: this.alllastlist[0].zhizaofeiyonglv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhizaofeiyonglv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhizaofeiyonglv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhizaofeiyonglv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhizaofeiyonglv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhizaofeiyonglv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhizaofeiyonglv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhizaofeiyonglv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhizaofeiyonglv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhizaofeiyonglv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhizaofeiyonglv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhizaofeiyonglv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhizaofeiyonglv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhizaofeiyonglv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhizaofeiyonglv,
                        canshuxulie2: 'zhizaofeiyonglv',
//60
                    },
                ];

                console.log(this.beigaishude,"this.beigaishudeasdasdasd")

                //增加默认属性  财务改数flag
                for (var d in this.tableData) {

                    this.tableData[d].shifougaishu1 = false;
                    this.tableData[d].shifougaishu2 = false;
                    this.tableData[d].shifougaishu3 = false;
                    this.tableData[d].shifougaishu4 = false;
                    this.tableData[d].shifougaishu5 = false;
					this.tableData[d].shifougaishu6 = false;
					this.tableData[d].shifougaishu7 = false;
					this.tableData[d].shifougaishu8 = false;
					this.tableData[d].shifougaishu9 = false;
					this.tableData[d].shifougaishu10 = false;
					this.tableData[d].shifougaishu11 = false;
					this.tableData[d].shifougaishu12 = false;
					this.tableData[d].shifougaishu13 = false;
					this.tableData[d].shifougaishu14 = false;
					this.tableData[d].shifougaishu15 = false;
					this.tableData[d].flags1 = false;
					this.tableData[d].flags2 = false;
					this.tableData[d].flags3 = false;
					this.tableData[d].flags4 = false;
					this.tableData[d].flags5 = false;
					this.tableData[d].flags6 = false;
					this.tableData[d].flags7 = false;
					this.tableData[d].flags8 = false;
					this.tableData[d].flags9 = false;
					this.tableData[d].flags10 = false;
					this.tableData[d].flags11 = false;
					this.tableData[d].flags12 = false;
					this.tableData[d].flags13 = false;
					this.tableData[d].flags14 = false;
					this.tableData[d].flags15 = false;

                    for(var dd in this.beigaishude){

                        if(this.beigaishude[dd].canshuxulie==this.tableData[d].canshuxulie&&this.beigaishude[dd].flag==true){

                            this.tableData[d][this.beigaishude[dd].xinghaoji] = true;

                        }

                    }

                }



                this.ProMain.zhongduanchengjiaojia = allrate.zhongduanchengjiaojia?(parseFloat(allrate.zhongduanchengjiaojia).toFixed(2)):0 ;
                this.ProMain.zhuanyingshangmaolilv = allrate.zhuanyingshangmaolilv?(parseFloat(allrate.zhuanyingshangmaolilv).toFixed(2)):0 ;


                if (this.rateFormulaRenewXiangmucanshu != null) {


                }


                //加载总利率
                this.jiazaizonglilv(allrate);

                //比较毛利率
                this.shifoudadaoyinglimubiao();


                if(this.jisuancishu==0){

                    //多存一个tableData
                    this.baocuntable = this.clone(this.tableData);

                }

            },




            //加载总利率
            jiazaizonglilv(q){

                //存在总额
                if (q) {

                    console.log(q.savenum,'q.savenum')

                    //遍历总额
                    for (var c in q) {

                        if(q[c]!=null&&q[c]!=''){

                            //遍历表
                            for (var ccc in this.tableData) {



                                //若参数序列对应结果key
                                if (this.tableData[ccc].canshuxulie2 == c) {



                                    //取平均值  zhongduanchengjiaojia终端成交价   zhuanyingshangmaolilv专营商毛利率   onemoney单台一级供价  zhekoulv折扣率  wuliufeiyongdanweitiji单台体积  dantaianzhuangfei单台安装费
                                    this.divfangfa(c,'zhongduanchengjiaojia',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhuanyingshangmaolilv',ccc,'hejiE'.hejiE,q[c],q.savenum);
                                    this.divfangfa(c,'onemoney',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhekoulv',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhekoulv',ccc,'hejiL',q[c],q.savenum);
                                    this.divfangfa(c,'wuliufeiyongdanweitiji',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'dantaianzhuangfei',ccc,'hejiE',q[c],q.savenum);



                                    //shenqingdanjia申请单价
                                    this.divfangfa(c,'shenqingdanjia',ccc,'hejiE',q.dingdanjine,q.productNum);


                                    //dantaichengben单台成本
                                    this.divfangfa(c,'dantaichengben',ccc,'hejiE',q.maolichengbenheji,q.productNum);




                                    //maolimaolilv材料毛利率
                                    this.divfangfa(c,'maolimaolilv',ccc,'hejiE',q.maolimaoli,q.buhanshuishouru);

                                    //maolimaolilv材料毛利率
                                    this.divfangfa(c,'maolimaolilv',ccc,'hejiL',q.maolimaoli,q.buhanshuishouru);

                                    //jingyinggongxianlv经营贡献率
                                    this.divfangfa(c,'jingyinggongxianlv',ccc,'hejiE',q.jingyinggongxiansan,q.buhanshuishouru);

                                    //jingyinggongxianlv经营贡献率
                                    this.divfangfa(c,'jingyinggongxianlv',ccc,'hejiL',q.jingyinggongxiansan,q.buhanshuishouru);


                                    //lirunlirunlv利润率
                                    this.divfangfa(c,'lirunlirunlv',ccc,'hejiE',q.lirunsan,q.buhanshuishouru);

                                    //lirunlirunlv利润率
                                    this.divfangfa(c,'lirunlirunlv',ccc,'hejiL',q.lirunsan,q.buhanshuishouru);


                                    //盈利情况 材料毛利 合计率
                                    this.divfangfa(c,'yinglicailiaomaoli',ccc,'hejiL',q.maolimaoli,q.buhanshuishouru);

                                    //盈利情况 经营贡献 合计率
                                    this.divfangfa(c,'jingyinggongxian',ccc,'hejiL',q.jingyinggongxiansan,q.buhanshuishouru);

                                    //盈利情况 利润 合计率
                                    this.divfangfa(c,'yinglilirun',ccc,'hejiL',q.lirunsan,q.buhanshuishouru);




                                }




                            }

                        }



                    }

                }

            },


            divfangfa(c,c1,ccc,heji,z,z1){

                if(c==c1){

                    if(z!=''&&z1!=''&&z!=0&&z1!=0){


                        this.tableData[ccc][heji] = (new big(parseFloat(z)).div(parseFloat(z1)).toString());


                    }else{

                        this.tableData[ccc][heji] = 0;

                    }

                }



            },







            //深拷贝递归
            clone(o) {
                var temp = {};
                for (var k in o) {
                    if (typeof o[k] == 'object') {
                        temp[k] = this.clone(o[k]);
                    } else {
                        temp[k] = o[k];
                    }
                }
                return temp;
            },


            //判断是否达到盈利目标
            shifoudadaoyinglimubiao() {


                var mailizong = 0;
                var maolibiao = 0;
                var geshu = 0;

                for (var g in this.alllastlist) {

                    geshu++;

                    console.log(this.alllastlist[g].maolimaolilv, '总毛利')

                    this.zongmaolilv += parseFloat(this.alllastlist[g].maolimaolilv);


                    console.log(this.alllastlist[g].sunyibiaocailiaomaolilv, '总毛利表')

                    this.zongmaolilvbiao += parseFloat(this.alllastlist[g].sunyibiaocailiaomaolilv);


                    console.log(this.alllastlist[g].jingyinggongxiansan, '经营贡献总')

                    this.jingyinggongxiangzong += parseFloat(this.alllastlist[g].jingyinggongxiansan);


                    console.log(this.alllastlist[g].lirunsan, '利润总')

                    this.lirunzong += parseFloat(this.alllastlist[g].lirunsan);

                }

                mailizong = new big(this.zongmaolilv).div(geshu).toString();
                maolibiao = new big(this.zongmaolilvbiao).div(geshu).toString();
                this.zongmaolilvbiao = maolibiao;
                this.zongmaolilv = parseInt((mailizong *= 100));
                console.log(this.zongmaolilvbiao, '总毛利率表值')
                console.log(this.zongmaolilv, '总毛利率值')


                if (this.tableData && this.tableData.length > 0 ? this.tableData[45].hejiE == null || this.tableData[45].hejiE == '' ? false : true : false) {

                    if (this.tableData[45].hejiE >= 0.25) {

                        this.xianshinage = 0;

                    } else {

                        this.xianshinage = 1;
                    }

                }


            },

            caiwuzancunjisuan(inputto, q) {
                console.log(inputto,"梁婕0987654321");

                //调接口回调方法
                ss.FormulaNew.getAllRateByChanPincaiwuzancun(inputto).then(rd => {

                    if (JSON.stringify(rd.rateFormulaRenewVer) != '{}') {

                        this.rversion = rd.rateFormulaRenewVer.rversion;

                    }

                    //若是提交的
                    if (q == 3) {

                        this.$router.push({path: '/personal/dealCenter'});

                    }

                    //部署信息
                    this.bushujichuxinxi(rd);

                });

            },


            jisuan(inputto, q) {
                 console.log(inputto,"梁婕22222222222222222222222");

                //调接口回调方法
                ss.FormulaNew.getAllRateByChanPin(inputto).then(rd => {
                      console.log(rd,"梁婕33333333333333333333333333");
                    //若是提交的
                    if (q == 3) {

                        this.$router.push({path: '/personal/dealCenter'});

                    }
                   
                    //部署信息
                    this.bushujichuxinxi(rd);

                });

            },


            //判断instid
            panduaninstid(re){

                //存在审批instid
                if(re.instid!=null){

                    this.instid = re.instid

                    //不存在
                }else{

                    //如果已经通过，说明是财务修改直接通过的
                    if(re.status==2 && re.xid!=null){

                        this.caiwugaishutongguo = true;

                    }

                }

            },


            //部署信息
            bushujichuxinxi(rd) {

                console.log(rd, '看看查到参数')

                this.jiazaijieguoxinxi(rd);

                //存在上部信息
                if (rd.result) {

                    //项目名称
                    this.ProMain.projectName = rd.result.projectName;

                    //项目描述
                    this.ProMain.projectDescription = rd.result.projectDescription;

                    //不是项目
                } else {

                    //不是项目
                    this.ispro = false;

                }

                // //专营商毛利率
                // this.ProMain.zhuanyingshangmaolilv = rd.result.zhuanyingshangmaolilv;

                //下部列表所有计算查询返回信息
                var listrd = rd.marnesList;

                var allrate = rd.allrate;

                //返回计算版本
                this.rateFormulaRenewVer = rd.rateFormulaRenewVer;

                //判断instid
                this.panduaninstid(rd.rateFormulaRenewVer);

                console.log(rd, '看看啥玩意参数')


                if (rd.rateFormulaRenewXiangmucanshu) {

                    //从原始记录版本中回调回来的上部内容
                    this.rateFormulaRenewXiangmucanshu = rd.rateFormulaRenewXiangmucanshu;

                    //开标时间
                    this.ProMain.bid = rd.rateFormulaRenewXiangmucanshu.bid != null && rd.rateFormulaRenewXiangmucanshu.bid != '' && rd.rateFormulaRenewXiangmucanshu.bid != '0' && rd.rateFormulaRenewXiangmucanshu.bid != 0 ? this.$util.riQi(rd.rateFormulaRenewXiangmucanshu.bid) : null;


                    this.ProMain.bidway = rd.rateFormulaRenewXiangmucanshu.bidway ? rd.rateFormulaRenewXiangmucanshu.bidway : '';

                    this.repairtype = rd.rateFormulaRenewXiangmucanshu.baoxiuqi ? rd.rateFormulaRenewXiangmucanshu.baoxiuqi : '';

                    this.ProMain.pdpay = rd.rateFormulaRenewXiangmucanshu.f28 ? rd.rateFormulaRenewXiangmucanshu.f28 : '';

                    this.ProMain.fdpay = rd.rateFormulaRenewXiangmucanshu.f6 ? rd.rateFormulaRenewXiangmucanshu.f6 : '';

                    this.ProMain.mdpay = rd.rateFormulaRenewXiangmucanshu.f27 ? rd.rateFormulaRenewXiangmucanshu.f27 : '';

                    this.ProMain.ldpay = rd.rateFormulaRenewXiangmucanshu.f34 ? rd.rateFormulaRenewXiangmucanshu.f34 : '';

                    this.ProMain.fdpayday = rd.rateFormulaRenewXiangmucanshu.f23 ? rd.rateFormulaRenewXiangmucanshu.f23 : '';

                    this.ProMain.mdpayday = rd.rateFormulaRenewXiangmucanshu.f13 ? rd.rateFormulaRenewXiangmucanshu.f13 : '';

                    this.ProMain.ldpayday = rd.rateFormulaRenewXiangmucanshu.f30 ? rd.rateFormulaRenewXiangmucanshu.f30 : '';


                    //送达城市代码
                    //this.ProMain.songdachengshi = rd.rateFormulaRenewXiangmucanshu.songdachengshi ? rd.rateFormulaRenewXiangmucanshu.songdachengshi : '';

                    //送达地址
                    //this.ProMain.songdadizhi = rd.rateFormulaRenewXiangmucanshu.songdadizhi ? rd.rateFormulaRenewXiangmucanshu.songdadizhi : '';


                    //选中人
                   //this.ProMain.xuanzhongren = rd.rateFormulaRenewXiangmucanshu.xuanzhongren ? rd.rateFormulaRenewXiangmucanshu.xuanzhongren : '';

                    //使用人
                    //this.ProMain.shiyongren = rd.rateFormulaRenewXiangmucanshu.shiyongren ? rd.rateFormulaRenewXiangmucanshu.shiyongren : '';

                    //有效期
                    this.ProMain.youxiaoqi = [rd.rateFormulaRenewXiangmucanshu.youxiaoqistart || '', rd.rateFormulaRenewXiangmucanshu.youxiaoqi || ''];


                    console.log(rd.rateFormulaRenewXiangmucanshu, '看看回调')

                }


                //保存计算返回版本id
                if (rd.rateFormulaRenewVer.rversion) {
                    this.fanhuibanbenid = rd.rateFormulaRenewVer.rversion
                }

                console.log(allrate)

                this.allratemap = rd.allrate;

                //加载列
                this.addbiaotilie(listrd, allrate);

                this.shoucijiaohu = false;


            },

            //关闭选择框加载数据
            gettablecaiwuzancun() {

                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.getconfigsbycaiwu(0, this.rversion)

                }



            },

            //前后台交互
            getconfigsbycaiwu(q, s) {

                //计算前清空上次的计算过程
                this.rateFormulaRenewVer = {};

                this.xianshinage = 9;

                this.jingyinggongxiangzong = 0;

                this.lirunzong = 0;

                this.zongmaolilvbiao = 0;

                this.zongmaolilv = 0;


                var s17s14s3s12 = [];

                if (!this.shoucijiaohu) {

                    console.log(this.tableData[0].xinghao1, '看看编码')

                    for(var c = 1;c<16;c++){

                        s17s14s3s12.push({

                            proProductInfoId: this.tableData[0]['id' + c],
                            marcode: this.tableData[0]['xinghao' + c],
                            s17: this.tableData[9]['xinghao' + c],
                            s14: this.tableData[21]['xinghao' + c],
                            s3: this.tableData[30]['xinghao' + c],
                            s12: this.tableData[4]['xinghao' + c],

                        });

                    }

                    // s17s14s3s12 = [
                    //
                    //     {
                    //         proProductInfoId: this.tableData[0].id1,
                    //         marcode: this.tableData[0].xinghao1,
                    //         s17: this.tableData[9].xinghao1,
                    //         s14: this.tableData[21].xinghao1,
                    //         s3: this.tableData[30].xinghao1,
                    //         s12: this.tableData[4].xinghao1,
                    //     },
                    //
                    //     {
                    //         proProductInfoId: this.tableData[0].id2,
                    //         marcode: this.tableData[0].xinghao2,
                    //         s17: this.tableData[9].xinghao2,
                    //         s14: this.tableData[21].xinghao2,
                    //         s3: this.tableData[30].xinghao2,
                    //         s12: this.tableData[4].xinghao2,
                    //     },
                    //
                    //     {
                    //         proProductInfoId: this.tableData[0].id3,
                    //         marcode: this.tableData[0].xinghao3,
                    //         s17: this.tableData[9].xinghao3,
                    //         s14: this.tableData[21].xinghao3,
                    //         s3: this.tableData[30].xinghao3,
                    //         s12: this.tableData[4].xinghao3,
                    //     },
                    //
                    //     {
                    //         proProductInfoId: this.tableData[0].id4,
                    //         marcode: this.tableData[0].xinghao4,
                    //         s17: this.tableData[9].xinghao4,
                    //         s14: this.tableData[21].xinghao4,
                    //         s3: this.tableData[30].xinghao4,
                    //         s12: this.tableData[4].xinghao4,
                    //     },
                    //
                    //     {
                    //         proProductInfoId: this.tableData[0].id5,
                    //         marcode: this.tableData[0].xinghao5,
                    //         s17: this.tableData[9].xinghao5,
                    //         s14: this.tableData[21].xinghao5,
                    //         s3: this.tableData[30].xinghao5,
                    //         s12: this.tableData[4].xinghao5,
                    //     },
                    //
                    // ];

                    console.log(s17s14s3s12, '看看有没有?????')

                }
                ;


                var jiacan = [];

                for (var g in this.xiangmuchanpinlist) {

                    var dd = {
                        proProductInfoId: this.xiangmuchanpinlist[g].id,
                        marcode: this.xiangmuchanpinlist[g].productId,
                        s17: '0',
                        s14: '0',
                        s3: '0',
                        s12: '0',
                    };

                    jiacan.push(dd);

                }

                console.log(jiacan, '看看jiacan')


                //后台接口入参
                var inputto = {
                    "islengku":"1",
                    //"shiyongren": q == 0 ? "" : this.ProMain.shiyongren,//使用人usercode

                    "youxiaoqistart": q == 0 ? "" : this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi[0] == null ? null : this.$util.riQi(this.ProMain.youxiaoqi[0]) + "",//特价有效期
                    "youxiaoqi": q == 0 ? "" : this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi[1] == null ? null : this.$util.riQi(this.ProMain.youxiaoqi[1]) + "",//特价有效期

                    //"xuanzhongren": q == 0 ? "" : this.ProMain.xuanzhongren,//使用人username


                    //"songdachengshi": q == 0 ? "" : this.ProMain.songdachengshi,
                    //"songdadizhi": q == 0 ? "" : this.ProMain.songdadizhi,

                   
                    "f28": q == 0 ? "0" : this.ProMain.pdpay + '',
                    "f6": q == 0 ? "0" : this.ProMain.fdpay + '',
                    "f23": q == 0 ? "0" : this.ProMain.fdpayday + '',
                    "f27": q == 0 ? "0" : this.ProMain.mdpay + '',
                    "f13": q == 0 ? "0" : this.ProMain.mdpayday + '',
                    "f34": q == 0 ? "0" : this.ProMain.ldpay + '',
                    "f30": q == 0 ? "0" : this.ProMain.ldpayday + '',
                    "baoxiuqi": q == 0 ? "0" : this.repairtype + '',
                    // "s14": "10",
                    // "s3": "2",
                    "bid": q == 0 ? "" : this.ProMain.bid,
                    "bidway": q == 0 ? "zckceshi" : this.ProMain.bidway + '',
                    "s17s14s3s12": q == 0 ? jiacan : s17s14s3s12,
                    "savestatus": q == 2 ? 0 : q == 3 ? 1 : q == 13 ? 13 : null,//2暂存 对应传后台0   3提交 对应传后台1  13是修改直接通过  不是就null
                    "rversion": this.shoucijiaohu ? s == null ? this.rversion == null ? null : this.rversion : s : null,//计算版本
                    "xid": this.fanhuibanbenid == null ? this.rversion == null ? this.fanhuibanbenid : this.rversion : this.fanhuibanbenid,//之前的保存过的返回计算版本id

                };


                this.caiwuzancunjisuan(inputto, q);


            },

            //原始审批版本查看
            caiwuzancunyuanshibanben(){

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];

                this.getconfigs(0,this.rversion);

                this.dangqiancaiwuzancun = false;

            },


            //前后台交互
            getconfigs(q, s) {

                //计算前清空上次的计算过程
                this.rateFormulaRenewVer = {};

                this.xianshinage = 9;

                this.jingyinggongxiangzong = 0;

                this.lirunzong = 0;

                this.zongmaolilvbiao = 0;

                this.zongmaolilv = 0;


                var s17s14s3s12 = [];

                if (!this.shoucijiaohu) {

                    console.log(this.tableData[0].xinghao1, '看看编码')


                    for(var c = 1;c<16;c++){

                        s17s14s3s12.push({

                            proProductInfoId: this.tableData[0]['id' + c],
                            marcode: this.tableData[0]['xinghao' + c],
                            s17: this.tableData[9]['xinghao' + c],
                            s14: this.tableData[21]['xinghao' + c],
                            s3: this.tableData[30]['xinghao' + c],
                            s12: this.tableData[4]['xinghao' + c],

                        });

                    }

                    

                    console.log(s17s14s3s12, '看看有没有?????')

                }
                ;


                var jiacan = [];

                for (var g in this.xiangmuchanpinlist) {

                    var dd = {
                        proProductInfoId: this.xiangmuchanpinlist[g].id,
                        marcode: this.xiangmuchanpinlist[g].productId,
                        s17: '0',
                        s14: '0',
                        s3: '0',
                        s12: '0',
                    };

                    jiacan.push(dd);

                }

                console.log(jiacan, '看看jiacan')


                //后台接口入参
                var inputto = {
                    "islengku":"1",
                    "shiyongren": q == 0 ? "" : this.ProMain.shiyongren,//使用人usercode

                    "youxiaoqistart": q == 0 ? "" : this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi[0] == null ? null : this.$util.riQi(this.ProMain.youxiaoqi[0]) + "",//特价有效期
                    "youxiaoqi": q == 0 ? "" : this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi[1] == null ? null : this.$util.riQi(this.ProMain.youxiaoqi[1]) + "",//特价有效期

                    "xuanzhongren": q == 0 ? "" : this.ProMain.xuanzhongren,//使用人username


                    "songdachengshi": q == 0 ? "" : this.ProMain.songdachengshi,
                    "songdadizhi": q == 0 ? "" : this.ProMain.songdadizhi,

                    "f28": q == 0 ? "0" : this.ProMain.pdpay + '',
                    "f6": q == 0 ? "0" : this.ProMain.fdpay + '',
                    "f23": q == 0 ? "0" : this.ProMain.fdpayday + '',
                    "f27": q == 0 ? "0" : this.ProMain.mdpay + '',
                    "f13": q == 0 ? "0" : this.ProMain.mdpayday + '',
                    "f34": q == 0 ? "0" : this.ProMain.ldpay + '',
                    "f30": q == 0 ? "0" : this.ProMain.ldpayday + '',
                    "baoxiuqi": q == 0 ? "0" : this.repairtype + '',
                    // "s14": "10",
                    // "s3": "2",
                    "bid": q == 0 ? "" : this.ProMain.bid,
                    "bidway": q == 0 ? "zckceshi" : this.ProMain.bidway + '',
                    "s17s14s3s12": q == 0 ? jiacan : s17s14s3s12,
                    "savestatus": q == 2 ? 0 : q == 3 ? 1 : q == 13 ? 13 : null,//2暂存 对应传后台0   3提交 对应传后台1  13是修改直接通过  不是就null
                    "rversion": this.shoucijiaohu ? s == null ? this.rversion == null ? null : this.rversion : s : null,//计算版本
                    "xid": this.fanhuibanbenid == null ? this.rversion == null ? this.fanhuibanbenid : this.rversion : this.fanhuibanbenid,//之前的保存过的返回计算版本id

                };


                this.jisuan(inputto, q);


            },



            qiehuanbanbencaiwuzancun() {

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];

                //查找记录
                this.chazhaocaiwuzancun();
            },

            //查找财务暂存记录
            chazhaocaiwuzancun() {

                var rversion = {

                    rversion:this.rversion,

                }

                ss.FormulaNew.findcaiwuzancun(rversion).then(rd => {

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.showcaiwuzancun = false;


                    } else { //查到记录

                        var num = 0;

                        //遍历计算版本map
                        for (var i in rd.obj) {

                            //存计算版本
                            this.caiwuzancunlist.push(rd.obj[i])

                            console.log(i, '反正--------')

                            console.log(rd.obj[i], '---------反正')

                            console.log(i, 'i.rversion')


                            //加载计算版本下拉选
                            var d = {

                                instid: rd.obj[i].instid,
                                value: i,
                                label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                            }

                            console.log(d, 'dddddd??')

                            //计算版本选项
                            this.banbenop.push(d);


                            num++;

                        }

                        //弹出选框
                        this.showcaiwuzancun = true;

                    }


                })


            },



            //取消按钮
            quxiaoanniu() {

                //返回首页
                this.$router.push({path: '/personal/dealCenter'});

            },

            //单保存审批填写信息
            danbaocunshenpi(){

                this.tijiaoagain(15);

            },

            //驳回按钮
            bohuianniu(formname, q) {

				//q==1

				this.zancunbianlianga = q;//==1

                this.tonguoorbohui = q;

                this.$refs[formname].validate((valid) => {
                    if (valid) {

                        //先保存一个
                        this.danbaocunshenpi();

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },

            //通过按钮
            tongguoanniu(q) {
				//单保存时q==15

                this.tonguoorbohui = q;

                this.getxiugaijieguo(q,2)//单保存时q==15  n==2

            },


            //财务暂存
            caiwuzancun(){

                this.getxiugaijieguo(19,null)

            },

            //组织修改计算参数,发后台计算
            getxiugaijieguo(q,n) {


                var entityList = [];

                var suibiangai = [];

                for (var c = 0; c < 15; c++) {

                    if (this.tableData[0]['xinghao' + (c + 1)] != null && this.tableData[0]['xinghao' + (c + 1)] != '' && this.tableData[0]['xinghao' + (c + 1)] != '0') {

                        entityList.push({

                            "songdachengshi":this.ProMain.songdachengshi || '' + '',
                            "songdadizhi":this.ProMain.songdadizhi || '' + '',
                            "xuanzhongren":this.ProMain.xuanzhongren || '' + '',
                            "shiyongren":this.ProMain.shiyongren || '' + '',
                            "youxiaoqistart":this.ProMain.youxiaoqi!=null&&this.ProMain.youxiaoqi[0]!=null&&this.ProMain.youxiaoqi[0]!=''?(this.$util.riQi(this.ProMain.youxiaoqi[0]) || '' + ''):'',
                            "youxiaoqiend":this.ProMain.youxiaoqi!=null&&this.ProMain.youxiaoqi[1]!=null&&this.ProMain.youxiaoqi[0]!=''?(this.$util.riQi(this.ProMain.youxiaoqi[1]) || '' + ''):'',


                            "proProductInfoId": this.tableData[0]['id' + (c + 1)] != null ? this.tableData[0]['id' + (c + 1)] : '',//项目产品id

                            "ispro": this.ispro == true ? 1 : 0,//是否项目 0否  1是

                            "xid": this.rversion,//之前的保存过的返回计算版本id

                            "savestatus": q == 1 ? 3 : (q == 2||q==13) ? 2 : q == 15 ? 3:'',//2审核通过  3驳回

                            "bid": this.ProMain.bid || '' + '',//投标时间

                            "bidway": this.ProMain.bidway || '' + '',//投标方式

                            "baoxiuqi": this.repairtype || '' + '',//保修期

                            "s6": this.tableData[8]['xinghao' + (c + 1)] != null ? this.tableData[8]['xinghao' + (c + 1)] : '0',//销量

                            "marcode": this.tableData[0]['xinghao' + (c + 1)] != null ? this.tableData[0]['xinghao' + (c + 1)] : '0',//物料号

                            "f45": this.tableData[6]['xinghao' + (c + 1)] != null ? this.tableData[6]['xinghao' + (c + 1)] : '0',

                            "s17": this.tableData[9]['xinghao' + (c + 1)] != null ? this.tableData[9]['xinghao' + (c + 1)] : '0',

                            "s12": this.tableData[4]['xinghao' + (c + 1)] != null ? this.tableData[4]['xinghao' + (c + 1)] : '0',

                            "sunyibiaocailiaomaolilv": '0',

                            "t6": this.tableData[31]['xinghao' + (c + 1)] != null ? this.tableData[31]['xinghao' + (c + 1)] : '0',

                            "f48": this.tableData[16]['xinghao' + (c + 1)] != null ? this.tableData[16]['xinghao' + (c + 1)] : '0',

                            "f46": this.tableData[22]['xinghao' + (c + 1)] != null ? this.tableData[22]['xinghao' + (c + 1)] : '0',

                            "f50": this.tableData[24]['xinghao' + (c + 1)] != null ? this.tableData[24]['xinghao' + (c + 1)] : '0',

                            "f28": this.ProMain.pdpay + '',

                            "f6": this.ProMain.fdpay + '',

                            "f23": this.ProMain.fdpayday + '',

                            "f27": this.ProMain.mdpay + '',

                            "f13": this.ProMain.mdpayday + '',

                            "f34": this.ProMain.ldpay + '',

                            "f30": this.ProMain.ldpayday + '',

                            "s14": this.tableData[21]['xinghao' + (c + 1)] != null ? this.tableData[21]['xinghao' + (c + 1)] : '0',

                            "s3": this.tableData[30]['xinghao' + (c + 1)] != null ? this.tableData[30]['xinghao' + (c + 1)] : '0',


                            "leijizhizao": this.tableData[46]['xinghao' + (c + 1)] != null ? this.tableData[46]['xinghao' + (c + 1)] : '0',

                            "leijichengben": this.tableData[47]['xinghao' + (c + 1)] != null ? this.tableData[47]['xinghao' + (c + 1)] : '0',

                            "f5": this.tableData[48]['xinghao' + (c + 1)] != null ? this.tableData[48]['xinghao' + (c + 1)] : '0',

                            "f24": this.tableData[49]['xinghao' + (c + 1)] != null ? this.tableData[49]['xinghao' + (c + 1)] : '0',

                            "f44": this.tableData[50]['xinghao' + (c + 1)] != null ? this.tableData[50]['xinghao' + (c + 1)] : '0',

                            "f39": this.tableData[51]['xinghao' + (c + 1)] != null ? this.tableData[51]['xinghao' + (c + 1)] : '0',

                            "f41": this.tableData[52]['xinghao' + (c + 1)] != null ? this.tableData[52]['xinghao' + (c + 1)] : '0',

                            "f38": this.tableData[53]['xinghao' + (c + 1)] != null ? this.tableData[53]['xinghao' + (c + 1)] : '0',

                            "f36": this.tableData[54]['xinghao' + (c + 1)] != null ? this.tableData[54]['xinghao' + (c + 1)] : '0',

                            "f43": this.tableData[55]['xinghao' + (c + 1)] != null ? this.tableData[55]['xinghao' + (c + 1)] : '0',

                            "f37": this.tableData[56]['xinghao' + (c + 1)] != null ? this.tableData[56]['xinghao' + (c + 1)] : '0',

                            "f40": this.tableData[57]['xinghao' + (c + 1)] != null ? this.tableData[57]['xinghao' + (c + 1)] : '0',

                            "f35": this.tableData[58]['xinghao' + (c + 1)] != null ? this.tableData[58]['xinghao' + (c + 1)] : '0',

                            "f42": this.tableData[59]['xinghao' + (c + 1)] != null ? this.tableData[59]['xinghao' + (c + 1)] : '0',


                        });


                        suibiangai.push({


                            "g4": this.tableData[5]['shifougaishu' + (c + 1)] == true ? (this.tableData[5]['xinghao' + (c + 1)] != null ? this.tableData[5]['xinghao' + (c + 1)] : '0') : 'no',//专营商毛利率

                            "g5": this.tableData[7]['shifougaishu' + (c + 1)] == true ? (this.tableData[7]['xinghao' + (c + 1)] != null ? this.tableData[7]['xinghao' + (c + 1)] : '0') : 'no',//折扣率

                            "g6": this.tableData[10]['shifougaishu' + (c + 1)] == true ? (this.tableData[10]['xinghao' + (c + 1)] != null ? this.tableData[10]['xinghao' + (c + 1)] : '0') : 'no',//订单金额

                            "g7": this.tableData[11]['shifougaishu' + (c + 1)] == true ? (this.tableData[11]['xinghao' + (c + 1)] != null ? this.tableData[11]['xinghao' + (c + 1)] : '0') : 'no',//不含税订单收入

                            "t3": this.tableData[12]['shifougaishu' + (c + 1)] == true ? (this.tableData[12]['xinghao' + (c + 1)] != null ? this.tableData[12]['xinghao' + (c + 1)] : '0') : 'no',//盈亏平衡含税价

                            "g8": this.tableData[13]['shifougaishu' + (c + 1)] == true ? (this.tableData[13]['xinghao' + (c + 1)] != null ? this.tableData[13]['xinghao' + (c + 1)] : '0') : 'no',//材料毛利

                            "t4": this.tableData[14]['shifougaishu' + (c + 1)] == true ? (this.tableData[14]['xinghao' + (c + 1)] != null ? this.tableData[14]['xinghao' + (c + 1)] : '0') : 'no',//经营贡献

                            "t5": this.tableData[15]['shifougaishu' + (c + 1)] == true ? (this.tableData[15]['xinghao' + (c + 1)] != null ? this.tableData[15]['xinghao' + (c + 1)] : '0') : 'no',//利润

                            "g9": this.tableData[17]['shifougaishu' + (c + 1)] == true ? (this.tableData[17]['xinghao' + (c + 1)] != null ? this.tableData[17]['xinghao' + (c + 1)] : '0') : 'no',//成本合计

                            "g10": this.tableData[18]['shifougaishu' + (c + 1)] == true ? (this.tableData[18]['xinghao' + (c + 1)] != null ? this.tableData[18]['xinghao' + (c + 1)] : '0') : 'no',//毛利

                            "g11": this.tableData[19]['shifougaishu' + (c + 1)] == true ? (this.tableData[19]['xinghao' + (c + 1)] != null ? this.tableData[19]['xinghao' + (c + 1)] : '0') : 'no',//材料毛利率

                            "g12": this.tableData[20]['shifougaishu' + (c + 1)] == true ? (this.tableData[20]['xinghao' + (c + 1)] != null ? this.tableData[20]['xinghao' + (c + 1)] : '0') : 'no',//制造费用

                            "g13": this.tableData[23]['shifougaishu' + (c + 1)] == true ? (this.tableData[23]['xinghao' + (c + 1)] != null ? this.tableData[23]['xinghao' + (c + 1)] : '0') : 'no',//运费

                            "g14": this.tableData[25]['shifougaishu' + (c + 1)] == true ? (this.tableData[25]['xinghao' + (c + 1)] != null ? this.tableData[25]['xinghao' + (c + 1)] : '0') : 'no',//安装费

                            "g15": this.tableData[26]['shifougaishu' + (c + 1)] == true ? (this.tableData[26]['xinghao' + (c + 1)] != null ? this.tableData[26]['xinghao' + (c + 1)] : '0') : 'no',//维修费

                            "g16": this.tableData[27]['shifougaishu' + (c + 1)] == true ? (this.tableData[27]['xinghao' + (c + 1)] != null ? this.tableData[27]['xinghao' + (c + 1)] : '0') : 'no',//备件费

                            "g17": this.tableData[28]['shifougaishu' + (c + 1)] == true ? (this.tableData[28]['xinghao' + (c + 1)] != null ? this.tableData[28]['xinghao' + (c + 1)] : '0') : 'no',//退换机

                            "g18": this.tableData[29]['shifougaishu' + (c + 1)] == true ? (this.tableData[29]['xinghao' + (c + 1)] != null ? this.tableData[29]['xinghao' + (c + 1)] : '0') : 'no',//资金成本

                            "g20": this.tableData[32]['shifougaishu' + (c + 1)] == true ? (this.tableData[32]['xinghao' + (c + 1)] != null ? this.tableData[32]['xinghao' + (c + 1)] : '0') : 'no',//其他税费

                            "g21": this.tableData[33]['shifougaishu' + (c + 1)] == true ? (this.tableData[33]['xinghao' + (c + 1)] != null ? this.tableData[33]['xinghao' + (c + 1)] : '0') : 'no',//销售人工

                            "g22": this.tableData[34]['shifougaishu' + (c + 1)] == true ? (this.tableData[34]['xinghao' + (c + 1)] != null ? this.tableData[34]['xinghao' + (c + 1)] : '0') : 'no',//销售组织运营

                            "g23": this.tableData[35]['shifougaishu' + (c + 1)] == true ? (this.tableData[35]['xinghao' + (c + 1)] != null ? this.tableData[35]['xinghao' + (c + 1)] : '0') : 'no',//研发人工

                            "g24": this.tableData[36]['shifougaishu' + (c + 1)] == true ? (this.tableData[36]['xinghao' + (c + 1)] != null ? this.tableData[36]['xinghao' + (c + 1)] : '0') : 'no',//研发组织运营

                            "t7": this.tableData[37]['shifougaishu' + (c + 1)] == true ? (this.tableData[37]['xinghao' + (c + 1)] != null ? this.tableData[37]['xinghao' + (c + 1)] : '0') : 'no',//直接费用小计

                            "t8": this.tableData[38]['shifougaishu' + (c + 1)] == true ? (this.tableData[38]['xinghao' + (c + 1)] != null ? this.tableData[38]['xinghao' + (c + 1)] : '0') : 'no',//经营贡献

                            "t9": this.tableData[39]['shifougaishu' + (c + 1)] == true ? (this.tableData[39]['xinghao' + (c + 1)] != null ? this.tableData[39]['xinghao' + (c + 1)] : '0') : 'no',//经营贡献率

                            "g25": this.tableData[40]['shifougaishu' + (c + 1)] == true ? (this.tableData[40]['xinghao' + (c + 1)] != null ? this.tableData[40]['xinghao' + (c + 1)] : '0') : 'no',//销售费用

                            "g26": this.tableData[41]['shifougaishu' + (c + 1)] == true ? (this.tableData[41]['xinghao' + (c + 1)] != null ? this.tableData[41]['xinghao' + (c + 1)] : '0') : 'no',//管理费用

                            "g27": this.tableData[42]['shifougaishu' + (c + 1)] == true ? (this.tableData[42]['xinghao' + (c + 1)] != null ? this.tableData[42]['xinghao' + (c + 1)] : '0') : 'no',//研发费用

                            "g28": this.tableData[43]['shifougaishu' + (c + 1)] == true ? (this.tableData[43]['xinghao' + (c + 1)] != null ? this.tableData[43]['xinghao' + (c + 1)] : '0') : 'no',//平台费用小计

                            "t10": this.tableData[44]['shifougaishu' + (c + 1)] == true ? (this.tableData[44]['xinghao' + (c + 1)] != null ? this.tableData[44]['xinghao' + (c + 1)] : '0') : 'no',//利润

                            "t11": this.tableData[45]['shifougaishu' + (c + 1)] == true ? (this.tableData[45]['xinghao' + (c + 1)] != null ? this.tableData[45]['xinghao' + (c + 1)] : '0') : 'no',//利润率

                            "f3": this.tableData[60]['shifougaishu' + (c + 1)] == true ? (this.tableData[60]['xinghao' + (c + 1)] != null ? this.tableData[60]['xinghao' + (c + 1)] : '0') : 'no',//材料的制造费用率


                        });


                    }

                }

                console.log(entityList, 'adsfdsfdsf');


                var shenPiEntity = {

                    yewuzhujian: this.rversion,//业务主键

                    taskid: this.taskid,//页面拿到的taskid

                    optflag: q == 1||q==15 ? '驳回' : q == 2 ? '通过' : '',//'驳回' 或者 '通过'

                    msg: this.yinglishenpi.shenheyijian,//  页面填写的审核意见

                    tongguoorbohui: q,// 通过还是驳回的flag  1驳回  2通过

                    jiediantiaojianming: 'tongguoorbohui',//通过还是驳回的节点条件名字

                    instid: this.instid,//审批版本id


                };
              

                //调财务版计算参数
                var entity = {
                    
                    xid: this.rversion,
                    ispro: this.ispro == true ? 1 : 0,
                    status: q == 1 ? 3 : q == 2 ? 2 : q == 13 ? 13 : q == 15 ? 15 :q == 19 ?19:null,
                    shifousuibiangai: this.shenpiyemian == true ? 1 : 0,//是不是审批页面(随便改数)，是1  否0
                    rversion: this.rversion,
                    entityList: entityList,
                    suibiangai: suibiangai,
                    shenPiEntity: shenPiEntity,
                    islengku:1,
                };
              

				if(q==15){

					this.baocunbianliangb = this.rversion;

				}
                console.log(entity,'fdsfdsfffffffffffff');
                
                //调财务版计算
                ss.FormulaNew.caiwugaishu(entity).then(rd => {

                    console.log(rd, '后面计算得数都是***')

                    //不是财务只存
                    if(rd.f&&q!=15){

                            if (q == 1 || q == 2) {

								//驳回完事了
								if(n==1){

									console.log("开始进入驳回完事");

									var rversion = {

										rversion:this.baocunbianliangb,

									}

									ss.FormulaNew.fanzhuanop(rversion).then(rd => {

										//跳转
										this.shenpitiaozhuan();

									})

								}else{

									//跳转
									this.shenpitiaozhuan();

								}


                            }else if(q == 13){
                                console.log("看你是不是走这里了.你修改提交删除啥代办");
                                var c = {

                                    rversion:this.caiwuzhijiexiugaitijiaoshanchubanben,

                                }

                                //删除版本
                                //ss.FormulaHaiwai.luojishanchubanben(c).then(rd => {

                                    //跳转
                                    this.shenpitiaozhuan();

                                //})

                            }


                            if(q==19){

                              this.$msg.msgs('暂存成功')

                            }else{

                                this.zongmaolilv = 0;

                                this.jingyinggongxiangzong = 0;

                                this.lirunzong = 0;

                                this.bushujichuxinxi(rd);


                            }


					//是驳回财务先保存的
                    }else if(rd.f&&q==15){

						this.tonguoorbohui = this.zancunbianlianga;

						//tonguoorbohui==1

						this.getxiugaijieguo(this.zancunbianlianga,1); //q==1  n==1

					}




                })


            },

            //跳转待办
            shenpitiaozhuan() {

                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                })

            },




        }
    }

</script>
<style scoped>
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
        width: 8%;
    }

    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }
</style>
<style>
	.enter .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__label {
	    width: 11.5%;
	}

	.enter .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__content {
	    width: 88.5%;
	}
    .cccc .h-formbLine .el-form-item__label {
        width: 23%
    }

	.cccc .h-formbLine .el-form-item__content {
	    width: 77%
	}

    .enter .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .enter .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .enter .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .ljjrange .el-range-editor.is-disabled .el-range-separator {
        line-height: 18px;
    }
	.ljjtableenterlknsp .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtableenterlknsp .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>




